import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: any;
  UUID: any;
};

export enum ActionType {
  Log = 'LOG',
  Report = 'REPORT',
  Trace = 'TRACE'
}

export type ActionTypeMessageItem = {
  __typename?: 'ActionTypeMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export type AnalyteMessageItem = {
  __typename?: 'AnalyteMessageItem';
  analyteName: Scalars['String'];
  analyteUuid: Scalars['UUID'];
  avroSize: Scalars['Long'];
  operationType: OperationType;
  updated?: Maybe<Scalars['DateTime']>;
};

export type AnalyteRangeMessageItem = {
  __typename?: 'AnalyteRangeMessageItem';
  analyte?: Maybe<AnalyteMessageItem>;
  analyteRangeUuid: Scalars['UUID'];
  avroSize: Scalars['Long'];
  comments?: Maybe<Scalars['String']>;
  dataDictionaryName?: Maybe<Scalars['String']>;
  dataDictionaryNameUuid?: Maybe<Scalars['UUID']>;
  dataDictionaryUuid?: Maybe<Scalars['UUID']>;
  highRange?: Maybe<Scalars['Float']>;
  lab?: Maybe<LabMessageItem>;
  loincCode?: Maybe<Scalars['String']>;
  lowRange?: Maybe<Scalars['Float']>;
  operationType: OperationType;
  status?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type AppCountMetric = {
  __typename?: 'AppCountMetric';
  count: Scalars['Int'];
  label: Scalars['String'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type ArchitectMessage = EventMessage & IEventMessage & {
  __typename?: 'ArchitectMessage';
  body: ArchitectMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type ArchitectMessageBody = {
  __typename?: 'ArchitectMessageBody';
  crfDataDictionaries: Array<CrfDataDictionaryMessageItem>;
  crfDataDictionaryEntries: Array<CrfDataDictionaryEntryMessageItem>;
  crfDerivationSteps: Array<CrfDerivationStepMessageItem>;
  crfDerivations: Array<CrfDerivationMessageItem>;
  crfFieldRestrictions: Array<CrfFieldRestrictionMessageItem>;
  crfFieldReviewGroups: Array<CrfFieldReviewGroupMessageItem>;
  crfFields: Array<CrfFieldMessageItem>;
  crfFolderForms: Array<CrfFolderFormMessageItem>;
  crfFolders: Array<CrfFolderMessageItem>;
  crfFormRestrictions: Array<CrfFormRestrictionMessageItem>;
  crfForms: Array<CrfFormMessageItem>;
  crfMatrices: Array<CrfMatrixMessageItem>;
  crfUnitDictionaries: Array<CrfUnitDictionaryMessageItem>;
  crfUnitDictionaryEntries: Array<CrfUnitDictionaryEntryMessageItem>;
  crfVariables: Array<CrfVariableMessageItem>;
  crfVersions: Array<CrfVersionMessageItem>;
  dataDictionaryDefinitions: Array<DataDictionaryDefinitionMessageItem>;
  dataDictionaryEntryDefinitions: Array<DataDictionaryEntryDefinitionMessageItem>;
  dataDictionaryEntryVersions: Array<DataDictionaryEntryVersionMessageItem>;
  dataDictionaryVersions: Array<DataDictionaryVersionMessageItem>;
  derivationDefinitions: Array<DerivationDefinitionMessageItem>;
  derivationVersions: Array<DerivationVersionMessageItem>;
  fieldDefinitions: Array<FieldDefinitionMessageItem>;
  fieldVersions: Array<FieldVersionMessageItem>;
  folderDefinitions: Array<FolderDefinitionMessageItem>;
  folderVersions: Array<FolderVersionMessageItem>;
  formDefinitions: Array<FormDefinitionMessageItem>;
  formVersions: Array<FormVersionMessageItem>;
  matrixDefinitions: Array<MatrixDefinitionMessageItem>;
  matrixVersions: Array<MatrixVersionMessageItem>;
  metadata?: Maybe<ArchitectMetadata>;
  studies: Array<StudySupplementalItem>;
  unitDictionaryDefinitions: Array<UnitDictionaryDefinitionMessageItem>;
  unitDictionaryEntryDefinitions: Array<UnitDictionaryEntryDefinitionMessageItem>;
  unitDictionaryEntryVersions: Array<UnitDictionaryEntryVersionMessageItem>;
  unitDictionaryVersions: Array<UnitDictionaryVersionMessageItem>;
  variableDefinitions: Array<VariableDefinitionMessageItem>;
  variableVersions: Array<VariableVersionMessageItem>;
};

export type ArchitectMetadata = {
  __typename?: 'ArchitectMetadata';
  _mdsol_lineage?: Maybe<Array<Array<KeyValuePairOfStringAndString>>>;
  _mdsol_timeliness?: Maybe<Array<KeyValuePairOfStringAndString>>;
  _mdsol_updated_at?: Maybe<Scalars['DateTime']>;
  defaultLocale?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  jobRequestId?: Maybe<Scalars['UUID']>;
  messageContentType?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['UUID']>;
  messageTime?: Maybe<Scalars['DateTime']>;
  multiMessageCount?: Maybe<Scalars['Int']>;
  multiMessageIndex?: Maybe<Scalars['Int']>;
  multiMessageUuid?: Maybe<Scalars['UUID']>;
  raveDatabaseVersion?: Maybe<Scalars['String']>;
  raveUrl?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  roleUuid?: Maybe<Scalars['UUID']>;
  studyGroupUuid?: Maybe<Scalars['UUID']>;
  studyUuid?: Maybe<Scalars['UUID']>;
  targetObjectType?: Maybe<Scalars['String']>;
  targetObjectUuid?: Maybe<Scalars['UUID']>;
  traceparent?: Maybe<Scalars['String']>;
  transactionEndTime?: Maybe<Scalars['DateTime']>;
  transactionId?: Maybe<Scalars['String']>;
  userLogin?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['UUID']>;
};

export type AuditCategoryMessageItem = {
  __typename?: 'AuditCategoryMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export type AuditMessage = EventMessage & IEventMessage & {
  __typename?: 'AuditMessage';
  body: AuditMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type AuditMessageBody = {
  __typename?: 'AuditMessageBody';
  audits: Array<AuditMessageItem>;
  avroSize: Scalars['Long'];
  metadata?: Maybe<Metadata>;
};

export type AuditMessageItem = {
  __typename?: 'AuditMessageItem';
  auditSubCategoryId?: Maybe<Scalars['Int']>;
  auditTime: Scalars['DateTime'];
  auditUserUuid?: Maybe<Scalars['UUID']>;
  auditUuid: Scalars['UUID'];
  avroSize: Scalars['Long'];
  databaseTime?: Maybe<Scalars['DateTime']>;
  internalUserUuid?: Maybe<Scalars['UUID']>;
  objectTypeId?: Maybe<Scalars['Int']>;
  objectUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  property: Scalars['String'];
  readable: Scalars['String'];
  value: Scalars['String'];
};

export type AuditSubCategoryMessageItem = {
  __typename?: 'AuditSubCategoryMessageItem';
  auditCategoryId: Scalars['Int'];
  auditCategoryName: Scalars['String'];
  auditSubCategoryId: Scalars['Int'];
  auditSubCategoryName: Scalars['String'];
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type BulkEditConfigurationInput = {
  configuration: ConfigurationOptionValueInput;
  databaseIds: Array<Scalars['UUID']>;
};

export type BulkEditConfigurationPayload = {
  __typename?: 'BulkEditConfigurationPayload';
  requests: Array<JobRequest>;
};

export type BulkOperationDiagnostic = LegionDiagnostic & {
  __typename?: 'BulkOperationDiagnostic';
  data?: Maybe<Scalars['Any']>;
  enqueueTime: Scalars['DateTime'];
  environmentName: Scalars['String'];
  extracted: Scalars['Boolean'];
  id: Scalars['String'];
  objectIds?: Maybe<Array<Scalars['Int']>>;
  objectType: ObjectType;
  operationType: BulkOperationType;
  queueId: Scalars['Int'];
  reviewGroupId?: Maybe<Scalars['Int']>;
  roleId: Scalars['Int'];
  roleName: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
  studyId: Scalars['Int'];
  studyName: Scalars['String'];
  subjectId: Scalars['Int'];
  subjectName: Scalars['String'];
  subjectUuid: Scalars['UUID'];
  userId: Scalars['Int'];
  userName: Scalars['String'];
};

export type BulkOperationItemStatus = {
  __typename?: 'BulkOperationItemStatus';
  dataPointCount: Scalars['Int'];
  objectId: Scalars['Long'];
  result: Scalars['Boolean'];
  statusMask: Scalars['Int'];
};

export type BulkOperationJob = LegionJob & {
  __typename?: 'BulkOperationJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  requestSource?: Maybe<Scalars['String']>;
  status: JobStatus;
  studyId: Scalars['Int'];
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type BulkOperationTask = LegionTask & {
  __typename?: 'BulkOperationTask';
  attemptCount: Scalars['Int'];
  bulkOperationQueueId: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  objectIds: Array<Scalars['Long']>;
  objectTypeId: Scalars['Int'];
  operation: BulkOperationType;
  partitionKey: Scalars['String'];
  results?: Maybe<Array<BulkOperationItemStatus>>;
  reviewGroupId?: Maybe<Scalars['Int']>;
  roleId: Scalars['Int'];
  status: TaskItemStatus;
  studyId: Scalars['Int'];
  subjectId: Scalars['Int'];
  userId: Scalars['Int'];
};

export enum BulkOperationType {
  Freeze = 'FREEZE',
  Lock = 'LOCK',
  ProjectLock = 'PROJECT_LOCK',
  Review = 'REVIEW',
  Sign = 'SIGN',
  SubjectDelete = 'SUBJECT_DELETE',
  UnFreeze = 'UN_FREEZE',
  UnLock = 'UN_LOCK',
  UnReview = 'UN_REVIEW',
  UnVerify = 'UN_VERIFY',
  Verify = 'VERIFY'
}

export type ChangeDataDataLoadJob = LegionJob & {
  __typename?: 'ChangeDataDataLoadJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type ChangeDataDataLoadObject = {
  __typename?: 'ChangeDataDataLoadObject';
  objectIds: Array<Scalars['Long']>;
  objectTypeId: Scalars['Int'];
};

export type ChangeDataDataLoadTask = LegionTask & {
  __typename?: 'ChangeDataDataLoadTask';
  attemptCount: Scalars['Int'];
  changeDataDataLoadObjects?: Maybe<Array<ChangeDataDataLoadObject>>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  taskData: ChangeDataDataLoadTaskData;
};

export type ChangeDataDataLoadTaskData = LegionTaskData & {
  __typename?: 'ChangeDataDataLoadTaskData';
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  dataPointIds: Array<Scalars['Long']>;
  jobId: Scalars['UUID'];
  objectId?: Maybe<Scalars['Long']>;
  secondaryObjectIds: Array<Scalars['Long']>;
  subjectId: Scalars['Long'];
  taskId: Scalars['UUID'];
};

export type CheckActionResult = {
  __typename?: 'CheckActionResult';
  checkActionId: Scalars['Int'];
  checkId: Scalars['Int'];
  checkStepResult: Scalars['Boolean'];
  dataPageId: Scalars['Int'];
  dataPointId: Scalars['Long'];
  operation: CheckOperationType;
  runPass: Scalars['Int'];
  subjectId: Scalars['Int'];
  timestamp: Scalars['DateTime'];
};

export enum CheckOperationType {
  BalanceDispense = 'BALANCE_DISPENSE',
  BalancePdal = 'BALANCE_PDAL',
  BalanceRandomize = 'BALANCE_RANDOMIZE',
  BalanceRandomizeAndDispense = 'BALANCE_RANDOMIZE_AND_DISPENSE',
  BalanceReDispense = 'BALANCE_RE_DISPENSE',
  BalanceSubjectCreate = 'BALANCE_SUBJECT_CREATE',
  BalanceSubjectDeactivate = 'BALANCE_SUBJECT_DEACTIVATE',
  BalanceSubjectExclude = 'BALANCE_SUBJECT_EXCLUDE',
  CommentAdd = 'COMMENT_ADD',
  CommentInactivate = 'COMMENT_INACTIVATE',
  CtmsActivity = 'CTMS_ACTIVITY',
  CustomFunction = 'CUSTOM_FUNCTION',
  DataPageAdd = 'DATA_PAGE_ADD',
  DataPageDelete = 'DATA_PAGE_DELETE',
  DataPageSetDate = 'DATA_PAGE_SET_DATE',
  DataPageSetName = 'DATA_PAGE_SET_NAME',
  DataPageSetRequireSignature = 'DATA_PAGE_SET_REQUIRE_SIGNATURE',
  DataPointSetEmpty = 'DATA_POINT_SET_EMPTY',
  DataPointSetNonConformant = 'DATA_POINT_SET_NON_CONFORMANT',
  DataPointSetRequiresReview = 'DATA_POINT_SET_REQUIRES_REVIEW',
  DataPointSetRequiresVerification = 'DATA_POINT_SET_REQUIRES_VERIFICATION',
  DataPointSetSiteInformation = 'DATA_POINT_SET_SITE_INFORMATION',
  DataPointSetValue = 'DATA_POINT_SET_VALUE',
  DataPointSetVisible = 'DATA_POINT_SET_VISIBLE',
  DataPointUnsetNonConformant = 'DATA_POINT_UNSET_NON_CONFORMANT',
  DataPointUnsetRequiresReview = 'DATA_POINT_UNSET_REQUIRES_REVIEW',
  DataPointUnsetRequiresVerification = 'DATA_POINT_UNSET_REQUIRES_VERIFICATION',
  DynamicSearch = 'DYNAMIC_SEARCH',
  InstanceSetDate = 'INSTANCE_SET_DATE',
  InstanceSetName = 'INSTANCE_SET_NAME',
  InstanceSetRequireSignature = 'INSTANCE_SET_REQUIRE_SIGNATURE',
  IsPresent = 'IS_PRESENT',
  MessageSend = 'MESSAGE_SEND',
  NotificationSend = 'NOTIFICATION_SEND',
  ProtocolDeviationAdd = 'PROTOCOL_DEVIATION_ADD',
  ProtocolDeviationInactivate = 'PROTOCOL_DEVIATION_INACTIVATE',
  QueryAnswer = 'QUERY_ANSWER',
  QueryClose = 'QUERY_CLOSE',
  QueryOpen = 'QUERY_OPEN',
  QueryUpdate = 'QUERY_UPDATE',
  RecordSetDate = 'RECORD_SET_DATE',
  StickyAdd = 'STICKY_ADD',
  StickyInactivate = 'STICKY_INACTIVATE',
  SubjectMatrixAdd = 'SUBJECT_MATRIX_ADD',
  SubjectMatrixDelete = 'SUBJECT_MATRIX_DELETE',
  SubjectMatrixMerge = 'SUBJECT_MATRIX_MERGE',
  SubjectMatrixUnMerge = 'SUBJECT_MATRIX_UN_MERGE',
  SubjectSetDate = 'SUBJECT_SET_DATE',
  SubjectSetName = 'SUBJECT_SET_NAME',
  SubjectSetRequiresSignature = 'SUBJECT_SET_REQUIRES_SIGNATURE',
  SubjectSetSecondaryName = 'SUBJECT_SET_SECONDARY_NAME',
  SubjectSetStatus = 'SUBJECT_SET_STATUS',
  SubjectSetTimeForward = 'SUBJECT_SET_TIME_FORWARD',
  SubjectSetTimeZero = 'SUBJECT_SET_TIME_ZERO',
  SubjectSetUniqueName = 'SUBJECT_SET_UNIQUE_NAME'
}

export type CleaningEngineError = {
  __typename?: 'CleaningEngineError';
  dataPageId?: Maybe<Scalars['Int']>;
  fieldName?: Maybe<Scalars['String']>;
  fieldOid?: Maybe<Scalars['String']>;
  fieldUuid?: Maybe<Scalars['UUID']>;
  formName?: Maybe<Scalars['String']>;
  formOid?: Maybe<Scalars['String']>;
  formUuid?: Maybe<Scalars['UUID']>;
  message: Scalars['String'];
  operationName?: Maybe<Scalars['String']>;
  operationType: CleaningOperationType;
  recordPosition?: Maybe<Scalars['Int']>;
};

export type CleaningEngineRequest = {
  __typename?: 'CleaningEngineRequest';
  dataPageUuids: Array<Scalars['UUID']>;
  dataPointUuids: Array<Scalars['UUID']>;
  recordUuids: Array<Scalars['UUID']>;
  subjectUuid: Scalars['UUID'];
};

export type CleaningExecutionContext = {
  __typename?: 'CleaningExecutionContext';
  checkActions: Array<CheckActionResult>;
  errors: Array<CleaningEngineError>;
};

export enum CleaningOperationType {
  Derivation = 'DERIVATION',
  EditCheck = 'EDIT_CHECK',
  None = 'NONE'
}

export type ClientDivisionOrganizationMessageItem = {
  __typename?: 'ClientDivisionOrganizationMessageItem';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  avroSize: Scalars['Long'];
  city?: Maybe<Scalars['String']>;
  clientDivisionOrganizationId?: Maybe<Scalars['Long']>;
  clientDivisionOrganizationUuid: Scalars['UUID'];
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  eTag?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  lastExternalUpdateDate?: Maybe<Scalars['DateTime']>;
  oid?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  postalCode?: Maybe<Scalars['String']>;
  siteActive: Scalars['Boolean'];
  siteGroupId?: Maybe<Scalars['Int']>;
  siteName?: Maybe<Scalars['String']>;
  siteNameUuid?: Maybe<Scalars['UUID']>;
  siteNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type ClinicalSignificanceCodeMessageItem = {
  __typename?: 'ClinicalSignificanceCodeMessageItem';
  active: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  clinicalSignificanceCodeUuid: Scalars['UUID'];
  code: Scalars['String'];
  codeUuid: Scalars['UUID'];
  operationType: OperationType;
  updated?: Maybe<Scalars['DateTime']>;
};

export type ClinicalSignificanceMessageItem = {
  __typename?: 'ClinicalSignificanceMessageItem';
  avroSize: Scalars['Long'];
  clinicalSignificanceCodeUuid?: Maybe<Scalars['UUID']>;
  clinicalSignificanceUuid: Scalars['UUID'];
  comment?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  dataPointId?: Maybe<Scalars['Long']>;
  dataPointUuid: Scalars['UUID'];
  deleted: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated: Scalars['DateTime'];
};

export type CoderConfigMessage = EventMessage & IEventMessage & {
  __typename?: 'CoderConfigMessage';
  body: CoderConfigMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type CoderConfigMessageBody = {
  __typename?: 'CoderConfigMessageBody';
  avroSize: Scalars['Long'];
  codingColumns: Array<CodingColumnMessageItem>;
  codingDictionaries: Array<CodingDictionaryMessageItem>;
  metadata: Metadata;
};

export type CoderDecisionMessageItem = {
  __typename?: 'CoderDecisionMessageItem';
  avroSize: Scalars['Long'];
  coderDecisionId?: Maybe<Scalars['Long']>;
  coderDecisionUuid: Scalars['UUID'];
  codingDictionaryVersion: Scalars['String'];
  created: Scalars['DateTime'];
  dataPointUuid: Scalars['UUID'];
  deleted: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated: Scalars['DateTime'];
};

export type CoderValueMessageItem = {
  __typename?: 'CoderValueMessageItem';
  avroSize: Scalars['Long'];
  coderColumnUuid: Scalars['UUID'];
  coderDecisionUuid: Scalars['UUID'];
  coderValueId?: Maybe<Scalars['Long']>;
  coderValueUuid: Scalars['UUID'];
  codingColumnName?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  term: Scalars['String'];
  updated: Scalars['DateTime'];
  value: Scalars['String'];
};

export type CodingColumnMessageItem = {
  __typename?: 'CodingColumnMessageItem';
  avroSize: Scalars['Long'];
  codeMaxLength?: Maybe<Scalars['Int']>;
  codeSASSuffix?: Maybe<Scalars['String']>;
  codeSuffix?: Maybe<Scalars['String']>;
  codingColumnName: Scalars['String'];
  codingColumnUuid: Scalars['UUID'];
  codingDictionaryUuid: Scalars['UUID'];
  created?: Maybe<Scalars['DateTime']>;
  defaultCodingLevel: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  termMaxLength?: Maybe<Scalars['Int']>;
  termSASSuffix?: Maybe<Scalars['String']>;
  termSuffix?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type CodingDecisionJob = LegionJob & {
  __typename?: 'CodingDecisionJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  domainUuid: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type CodingDecisionTask = LegionTask & {
  __typename?: 'CodingDecisionTask';
  attemptCount: Scalars['Int'];
  coderUsername: Scalars['String'];
  decisionTerms: Array<DecisionTerm>;
  decisionUri: Scalars['String'];
  domainUuid: Scalars['UUID'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  studyEnvironmentUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
  supplementals: Array<KeyValuePairOfStringAndString>;
  taskUuid: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  verbatim: Scalars['String'];
};

export type CodingDictionaryMessageItem = {
  __typename?: 'CodingDictionaryMessageItem';
  avroSize: Scalars['Long'];
  codingDictionaryUuid: Scalars['UUID'];
  codingDomainName: Scalars['String'];
  codingDomainUuid?: Maybe<Scalars['UUID']>;
  created?: Maybe<Scalars['DateTime']>;
  dictionaryName?: Maybe<Scalars['String']>;
  dictionaryVersion?: Maybe<Scalars['String']>;
  isCoderDict: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type ConfigMessageItem = {
  __typename?: 'ConfigMessageItem';
  avroSize: Scalars['Long'];
  configKey: Scalars['String'];
  configValue: Scalars['String'];
  created: Scalars['DateTime'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated: Scalars['DateTime'];
};

export type ConfigurationMessage = EventMessage & IEventMessage & {
  __typename?: 'ConfigurationMessage';
  body: ConfigurationMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type ConfigurationMessageBody = {
  __typename?: 'ConfigurationMessageBody';
  avroSize: Scalars['Long'];
  configurations: Array<ConfigMessageItem>;
  localizations: Array<LocalizationMessageItem>;
  markingGroups: Array<MarkingGroupMessageItem>;
  metadata?: Maybe<Metadata>;
  protocolDeviationClasses?: Maybe<Array<ProtocolDeviationClassMessageItem>>;
  protocolDeviationCodes?: Maybe<Array<ProtocolDeviationCodeMessageItem>>;
  reviewGroups?: Maybe<Array<ReviewGroupMessageItem>>;
  roleActions: Array<RoleActionMessageItem>;
  roleSubjectStatusAccesses?: Maybe<Array<RoleSubjectStatusAccessMessageItem>>;
  roles: Array<RoleMessageItem>;
  subjectStatuses: Array<SubjectStatusMessageItem>;
};

export type ConfigurationOption = {
  __typename?: 'ConfigurationOption';
  groupName: Scalars['String'];
  label: Scalars['String'];
  tag: Scalars['String'];
  type: ConfigurationOptionType;
};

export enum ConfigurationOptionType {
  Boolean = 'BOOLEAN',
  Integer = 'INTEGER',
  String = 'STRING',
  TimeSpan = 'TIME_SPAN'
}

export type ConfigurationOptionValue = {
  __typename?: 'ConfigurationOptionValue';
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type ConfigurationOptionValueInput = {
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type CrfDataDictionaryEntryMessageItem = {
  __typename?: 'CrfDataDictionaryEntryMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfDataDictionaryEntryId?: Maybe<Scalars['Long']>;
  crfDataDictionaryEntryUuid: Scalars['UUID'];
  crfDataDictionaryUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  dataDictionaryDefinitionUuid: Scalars['UUID'];
  dataDictionaryEntryDefinitionUuid: Scalars['UUID'];
  dataDictionaryEntryVersionUuid: Scalars['UUID'];
  externalUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  ordinal: Scalars['Int'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfDataDictionaryMessageItem = {
  __typename?: 'CrfDataDictionaryMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfDataDictionaryId?: Maybe<Scalars['Long']>;
  crfDataDictionaryUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  dataDictionaryDefinitionUuid: Scalars['UUID'];
  dataDictionaryVersionUuid: Scalars['UUID'];
  externalUuid?: Maybe<Scalars['UUID']>;
  externalVersionNumber?: Maybe<Scalars['Int']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfDerivationMessageItem = {
  __typename?: 'CrfDerivationMessageItem';
  active: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfDerivationId?: Maybe<Scalars['Long']>;
  crfDerivationUuid: Scalars['UUID'];
  crfFieldUuid?: Maybe<Scalars['UUID']>;
  crfFolderUuid?: Maybe<Scalars['UUID']>;
  crfVersionUuid: Scalars['UUID'];
  deleted: Scalars['Boolean'];
  derivationDefinitionUuid: Scalars['UUID'];
  derivationOid: Scalars['String'];
  derivationVersionUuid: Scalars['UUID'];
  fieldDefinitionUuid?: Maybe<Scalars['UUID']>;
  folderDefinitionUuid?: Maybe<Scalars['UUID']>;
  hasMaxMinLRP?: Maybe<Scalars['Boolean']>;
  hasOrderLRP?: Maybe<Scalars['Boolean']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfDerivationStepMessageItem = {
  __typename?: 'CrfDerivationStepMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfCustomFunctionUuid?: Maybe<Scalars['UUID']>;
  crfDerivationStepId?: Maybe<Scalars['Long']>;
  crfDerivationStepUuid: Scalars['UUID'];
  crfDerivationUuid: Scalars['UUID'];
  crfFieldUuid?: Maybe<Scalars['UUID']>;
  crfFolderUuid?: Maybe<Scalars['UUID']>;
  crfVariableUuid?: Maybe<Scalars['UUID']>;
  crfVersionUuid: Scalars['UUID'];
  customFunctionDefinitionUuid?: Maybe<Scalars['UUID']>;
  dataFormat?: Maybe<Scalars['String']>;
  derivationDefinitionUuid: Scalars['UUID'];
  fieldDefinitionUuid?: Maybe<Scalars['UUID']>;
  folderDefinitionUuid?: Maybe<Scalars['UUID']>;
  instanceRepeatNumber?: Maybe<Scalars['Int']>;
  logicalRecordPosition?: Maybe<Scalars['Int']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  pageRepeatNumber?: Maybe<Scalars['Int']>;
  recordPosition?: Maybe<Scalars['Int']>;
  stepFunction?: Maybe<Scalars['String']>;
  stepOrdinal: Scalars['Long'];
  stepValue?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
  variableDefinitionUuid?: Maybe<Scalars['UUID']>;
};

export type CrfFieldMessageItem = {
  __typename?: 'CrfFieldMessageItem';
  avroSize: Scalars['Long'];
  columnOrdinal?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  crfFieldExternalUuid?: Maybe<Scalars['UUID']>;
  crfFieldId?: Maybe<Scalars['Long']>;
  crfFieldUuid: Scalars['UUID'];
  crfFormUuid: Scalars['UUID'];
  crfVariableUuid?: Maybe<Scalars['UUID']>;
  crfVersionUuid: Scalars['UUID'];
  fieldActive: Scalars['Boolean'];
  fieldDefinitionUuid: Scalars['UUID'];
  fieldVersionUuid: Scalars['UUID'];
  formDefinitionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  ordinal?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
  variableDefinitionUuid?: Maybe<Scalars['UUID']>;
};

export type CrfFieldRestrictionMessageItem = {
  __typename?: 'CrfFieldRestrictionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfFieldRestrictionId?: Maybe<Scalars['Long']>;
  crfFieldRestrictionUuid: Scalars['UUID'];
  crfFieldUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  restrictionType?: Maybe<Scalars['Int']>;
  roleUuid: Scalars['UUID'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfFieldReviewGroupMessageItem = {
  __typename?: 'CrfFieldReviewGroupMessageItem';
  avroSize: Scalars['Long'];
  crfFieldReviewGroupUuid: Scalars['UUID'];
  crfFieldUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  fieldId?: Maybe<Scalars['Long']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  reviewGroupId?: Maybe<Scalars['Int']>;
  reviewGroupUuid: Scalars['UUID'];
};

export type CrfFolderFormMessageItem = {
  __typename?: 'CrfFolderFormMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfFolderFormExternalUuid?: Maybe<Scalars['UUID']>;
  crfFolderFormId?: Maybe<Scalars['Long']>;
  crfFolderFormUuid: Scalars['UUID'];
  crfFolderUuid?: Maybe<Scalars['UUID']>;
  crfFormUuid: Scalars['UUID'];
  crfMatrixUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfFolderMessageItem = {
  __typename?: 'CrfFolderMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfFolderExternalUuid?: Maybe<Scalars['UUID']>;
  crfFolderId?: Maybe<Scalars['Long']>;
  crfFolderUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  folderDefinitionUuid: Scalars['UUID'];
  folderVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  ordinal: Scalars['Int'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfFormMessageItem = {
  __typename?: 'CrfFormMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfFormExternalUuid?: Maybe<Scalars['UUID']>;
  crfFormExternalVersionNumber?: Maybe<Scalars['Int']>;
  crfFormId?: Maybe<Scalars['Long']>;
  crfFormUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  formActive: Scalars['Boolean'];
  formDefinitionUuid: Scalars['UUID'];
  formVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  ordinal?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfFormRestrictionMessageItem = {
  __typename?: 'CrfFormRestrictionMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  crfFormRestrictionId?: Maybe<Scalars['Long']>;
  crfFormRestrictionUuid: Scalars['UUID'];
  crfFormUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  restrictionType?: Maybe<Scalars['Int']>;
  roleUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type CrfMatrixMessageItem = {
  __typename?: 'CrfMatrixMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfMatrixExternalUuid?: Maybe<Scalars['UUID']>;
  crfMatrixExternalVersionNumber?: Maybe<Scalars['Int']>;
  crfMatrixId?: Maybe<Scalars['Long']>;
  crfMatrixUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  matrixDefinitionUuid: Scalars['UUID'];
  matrixVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfMetadata = {
  __typename?: 'CrfMetadata';
  _mdsol_lineage?: Maybe<Array<Array<KeyValuePairOfStringAndString>>>;
  _mdsol_timeliness?: Maybe<Array<KeyValuePairOfStringAndString>>;
  _mdsol_updated_at?: Maybe<Scalars['DateTime']>;
  defaultLocale?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  jobRequestId?: Maybe<Scalars['UUID']>;
  messageContentType?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['UUID']>;
  messageTime?: Maybe<Scalars['DateTime']>;
  multiMessageCount?: Maybe<Scalars['Int']>;
  multiMessageIndex?: Maybe<Scalars['Int']>;
  multiMessageUuid?: Maybe<Scalars['UUID']>;
  raveDatabaseVersion?: Maybe<Scalars['String']>;
  raveUrl?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  roleUuid?: Maybe<Scalars['UUID']>;
  studyGroupUuid?: Maybe<Scalars['UUID']>;
  studyName?: Maybe<Scalars['String']>;
  studyUuid?: Maybe<Scalars['UUID']>;
  targetObjectType?: Maybe<Scalars['String']>;
  targetObjectUuid?: Maybe<Scalars['UUID']>;
  traceparent?: Maybe<Scalars['String']>;
  transactionEndTime?: Maybe<Scalars['DateTime']>;
  transactionId?: Maybe<Scalars['String']>;
  userLogin?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['UUID']>;
};

export type CrfUnitDictionaryEntryMessageItem = {
  __typename?: 'CrfUnitDictionaryEntryMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfUnitDictionaryEntryId?: Maybe<Scalars['Long']>;
  crfUnitDictionaryEntryUuid: Scalars['UUID'];
  crfUnitDictionaryUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  externalUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  ordinal?: Maybe<Scalars['Int']>;
  unitDictionaryDefinitionUuid: Scalars['UUID'];
  unitDictionaryEntryDefinitionUuid: Scalars['UUID'];
  unitDictionaryEntryVersionUuid: Scalars['UUID'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfUnitDictionaryMessageItem = {
  __typename?: 'CrfUnitDictionaryMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfUnitDictionaryId?: Maybe<Scalars['Long']>;
  crfUnitDictionaryUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  externalUuid?: Maybe<Scalars['UUID']>;
  externalVersionNumber?: Maybe<Scalars['Int']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  standardCrfUnitDictionaryEntryId?: Maybe<Scalars['UUID']>;
  standardUnitDictionaryEntryDefinitionUuid?: Maybe<Scalars['UUID']>;
  unitDictionaryDefinitionUuid: Scalars['UUID'];
  unitDictionaryOid?: Maybe<Scalars['String']>;
  unitDictionaryVersionUuid: Scalars['UUID'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfVariableMessageItem = {
  __typename?: 'CrfVariableMessageItem';
  avroSize: Scalars['Long'];
  codingDictionaryId?: Maybe<Scalars['UUID']>;
  created?: Maybe<Scalars['DateTime']>;
  crfDataDictionaryUuid?: Maybe<Scalars['UUID']>;
  crfDerivationUuid?: Maybe<Scalars['UUID']>;
  crfUnitDictionaryUuid?: Maybe<Scalars['UUID']>;
  crfVariableId?: Maybe<Scalars['Long']>;
  crfVariableUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  dataDictionaryDefinitionUuid?: Maybe<Scalars['UUID']>;
  deleted: Scalars['Boolean'];
  derivationDefinitionUuid?: Maybe<Scalars['UUID']>;
  isUsingCoder: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  unitDictionaryDefinitionUuid?: Maybe<Scalars['UUID']>;
  updated?: Maybe<Scalars['DateTime']>;
  variableDefinitionUuid: Scalars['UUID'];
  variableVersionUuid: Scalars['UUID'];
};

export type CrfVersionJob = LegionJob & {
  __typename?: 'CrfVersionJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  crfVersionUuid: Scalars['UUID'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type CrfVersionMessage = EventMessage & IEventMessage & {
  __typename?: 'CrfVersionMessage';
  body: CrfVersionMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type CrfVersionMessageBody = {
  __typename?: 'CrfVersionMessageBody';
  alertLabUuid?: Maybe<Scalars['UUID']>;
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  crfVersionId: Scalars['Long'];
  crfVersionName: Scalars['String'];
  crfVersionNameId: Scalars['Long'];
  crfVersionNameUuid?: Maybe<Scalars['UUID']>;
  crfVersionUuid: Scalars['UUID'];
  defaultMatrixDefinitionUuid: Scalars['UUID'];
  ecoaExternalUuid?: Maybe<Scalars['UUID']>;
  ecoaExternalVersionNumber?: Maybe<Scalars['Int']>;
  edcExternalUuid?: Maybe<Scalars['UUID']>;
  edcExternalVersionNumber?: Maybe<Scalars['Int']>;
  hasClinicalData: Scalars['Boolean'];
  isDraft: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  isValid?: Maybe<Scalars['Boolean']>;
  labStandardGroupUuid?: Maybe<Scalars['UUID']>;
  metadata?: Maybe<CrfMetadata>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  primaryFormDefinitionUuid: Scalars['UUID'];
  referenceLabUuid?: Maybe<Scalars['UUID']>;
  studyUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type CrfVersionMessageItem = {
  __typename?: 'CrfVersionMessageItem';
  alertLabUuid?: Maybe<Scalars['UUID']>;
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  crfVersionId: Scalars['Long'];
  crfVersionName?: Maybe<Scalars['String']>;
  crfVersionNameUuid: Scalars['UUID'];
  crfVersionUuid: Scalars['UUID'];
  defaultMatrixDefinitionUuid?: Maybe<Scalars['UUID']>;
  ecoaExternalUuid?: Maybe<Scalars['UUID']>;
  ecoaExternalVersionNumber?: Maybe<Scalars['Int']>;
  edcExternalUuid?: Maybe<Scalars['UUID']>;
  edcExternalVersionNumber?: Maybe<Scalars['Int']>;
  hasClinicalData: Scalars['Boolean'];
  isDraft: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  labStandardGroupUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  primaryFormDefinitionUuid?: Maybe<Scalars['UUID']>;
  referenceLabUuid?: Maybe<Scalars['UUID']>;
  studyUuid: Scalars['UUID'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type CrfVersionPublishTask = LegionTask & {
  __typename?: 'CrfVersionPublishTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
};

export type CrfVersionPublishTaskData = LegionTaskData & {
  __typename?: 'CrfVersionPublishTaskData';
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  jobId: Scalars['UUID'];
  taskId: Scalars['UUID'];
  versionName: Scalars['String'];
};

export type CustomConfigOverridesState = {
  __typename?: 'CustomConfigOverridesState';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CvRefreshDataPageSubTask = LegionTask & {
  __typename?: 'CvRefreshDataPageSubTask';
  attemptCount: Scalars['Int'];
  cvProjectFormStatsId: Scalars['Long'];
  dataPageId: Scalars['Int'];
  formOid?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  isIncrementalRefresh: Scalars['Boolean'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  projectId: Scalars['Int'];
  sortingOrdinal: Scalars['Int'];
  status: TaskItemStatus;
  timeToRefresh1Record: Scalars['Int'];
};

export type CvRefreshPopReportingRecordsJob = LegionJob & {
  __typename?: 'CvRefreshPopReportingRecordsJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type CvRefreshPopReportingRecordsTask = LegionTask & {
  __typename?: 'CvRefreshPopReportingRecordsTask';
  attemptCount: Scalars['Int'];
  dataPageIds: Array<Scalars['Int']>;
  formOid?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  isIncrementalRefresh: Scalars['Boolean'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  projectId: Scalars['Int'];
  status: TaskItemStatus;
  taskNumber: Scalars['Int'];
  timeToRefresh1Record?: Maybe<Scalars['Int']>;
};

export type CvRefreshTask = LegionTask & {
  __typename?: 'CvRefreshTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
};

export type CvRefreshTaskCreationJob = LegionJob & {
  __typename?: 'CvRefreshTaskCreationJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type DataDictionaryDefinitionMessageItem = {
  __typename?: 'DataDictionaryDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  dataDictionaryDefinitionUuid: Scalars['UUID'];
  dataDictionaryOid: Scalars['String'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
};

export type DataDictionaryEntryDefinitionMessageItem = {
  __typename?: 'DataDictionaryEntryDefinitionMessageItem';
  avroSize: Scalars['Long'];
  codedData?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dataDictionaryDefinitionUuid: Scalars['UUID'];
  dataDictionaryEntryDefinitionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
};

export type DataDictionaryEntryVersionMessageItem = {
  __typename?: 'DataDictionaryEntryVersionMessageItem';
  avroSize: Scalars['Long'];
  codedData?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  dataDictionaryDefinitionUuid: Scalars['UUID'];
  dataDictionaryEntryDefinitionUuid: Scalars['UUID'];
  dataDictionaryEntryOid?: Maybe<Scalars['String']>;
  dataDictionaryEntryVersionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  specify: Scalars['Boolean'];
  userDataString: Scalars['String'];
  userDataStringUuid: Scalars['UUID'];
};

export type DataDictionaryVersionMessageItem = {
  __typename?: 'DataDictionaryVersionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  dataDictionaryDefinitionUuid: Scalars['UUID'];
  dataDictionaryName: Scalars['String'];
  dataDictionaryNameUuid: Scalars['UUID'];
  dataDictionaryOid: Scalars['String'];
  dataDictionaryVersionUuid: Scalars['UUID'];
  hasOther: Scalars['Boolean'];
  nameSpaceId: Scalars['Int'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
};

export type DataPageMessageItem = {
  __typename?: 'DataPageMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  dataPageActive: Scalars['Boolean'];
  dataPageDate?: Maybe<Scalars['DateTime']>;
  dataPageId?: Maybe<Scalars['Long']>;
  dataPageName: Scalars['String'];
  dataPageUuid: Scalars['UUID'];
  deleted: Scalars['Boolean'];
  formExternalUuid?: Maybe<Scalars['UUID']>;
  formOid: Scalars['String'];
  formVersionUuid: Scalars['UUID'];
  instanceUuid?: Maybe<Scalars['UUID']>;
  isPrimaryDataPage: Scalars['Boolean'];
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  labUuid?: Maybe<Scalars['UUID']>;
  objectTagOids?: Maybe<Array<Scalars['String']>>;
  objectTagUuids?: Maybe<Array<Scalars['UUID']>>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  pageRepeatNumber: Scalars['Int'];
  reasonDescription?: Maybe<Scalars['String']>;
  reasonDescriptionUuid?: Maybe<Scalars['UUID']>;
  requiresSignature?: Maybe<Scalars['Boolean']>;
  subjectMatrixUuid?: Maybe<Scalars['UUID']>;
  subjectUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type DataPointCoding = {
  __typename?: 'DataPointCoding';
  avroSize: Scalars['Long'];
  coderDecisionUuid: Scalars['UUID'];
  codingDictionaryVersion: Scalars['String'];
  dataPointUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
  values: Array<DataPointCodingValue>;
};

export type DataPointCodingValue = {
  __typename?: 'DataPointCodingValue';
  avroSize: Scalars['Long'];
  coderValueUuid: Scalars['UUID'];
  codingColumnName?: Maybe<Scalars['String']>;
  dataPointUuid: Scalars['UUID'];
  term: Scalars['String'];
  value: Scalars['String'];
};

export type DataPointMessageItem = {
  __typename?: 'DataPointMessageItem';
  alertRangeUuid?: Maybe<Scalars['UUID']>;
  altCodedValue?: Maybe<Scalars['String']>;
  analyteRangeUuid?: Maybe<Scalars['UUID']>;
  attributeUri?: Maybe<Scalars['String']>;
  avroSize: Scalars['Long'];
  calculatedValuesUpdated?: Maybe<Scalars['DateTime']>;
  changeCodeUuid?: Maybe<Scalars['UUID']>;
  changeCount: Scalars['Int'];
  codedValue?: Maybe<Scalars['String']>;
  coding?: Maybe<DataPointCoding>;
  conceptUri?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  data: Scalars['String'];
  dataActive: Scalars['Boolean'];
  dataDictionaryEntryExternalUuid?: Maybe<Scalars['UUID']>;
  dataDictionaryEntryVersionUuid?: Maybe<Scalars['UUID']>;
  dataPointId?: Maybe<Scalars['Long']>;
  dataPointUuid: Scalars['UUID'];
  deleted: Scalars['Boolean'];
  deletedOrdinal: Scalars['Int'];
  enteredLabUnitName?: Maybe<Scalars['String']>;
  enteredLabUnitNameUuid?: Maybe<Scalars['UUID']>;
  enteredLabUnitUuid?: Maybe<Scalars['UUID']>;
  entryLocaleName?: Maybe<Scalars['String']>;
  entryLocaleUuid?: Maybe<Scalars['UUID']>;
  fieldControlType?: Maybe<Scalars['String']>;
  fieldExternalUuid?: Maybe<Scalars['UUID']>;
  fieldOid: Scalars['String'];
  fieldVersionUuid: Scalars['UUID'];
  isFrozen: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  isNonConformant: Scalars['Boolean'];
  isSignatureCurrent: Scalars['Boolean'];
  isTouched: Scalars['Boolean'];
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  isUsingCoder?: Maybe<Scalars['Boolean']>;
  isVerified: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  labData?: Maybe<LabData>;
  labNumericValue?: Maybe<Scalars['Float']>;
  labUnitUuid?: Maybe<Scalars['UUID']>;
  lastEnteredDate?: Maybe<Scalars['DateTime']>;
  lockTime?: Maybe<Scalars['DateTime']>;
  missingCodeDescription?: Maybe<Scalars['String']>;
  missingCodeDescriptionUuid?: Maybe<Scalars['UUID']>;
  missingCodeUuid?: Maybe<Scalars['UUID']>;
  objectTagOids?: Maybe<Array<Scalars['String']>>;
  objectTagUuids?: Maybe<Array<Scalars['UUID']>>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  rangeStatus: Scalars['Int'];
  rangeUpdated?: Maybe<Scalars['DateTime']>;
  recordUuid: Scalars['UUID'];
  referenceRangeUuid?: Maybe<Scalars['UUID']>;
  reqCoderCoding: Scalars['Boolean'];
  reqCoding: Scalars['Boolean'];
  reqTranslation: Scalars['Boolean'];
  reqVerification: Scalars['Boolean'];
  signatureLevel?: Maybe<Scalars['Int']>;
  standardValue?: Maybe<Scalars['String']>;
  tagNames?: Maybe<Array<Scalars['String']>>;
  unReviewedByInactivation?: Maybe<Scalars['Int']>;
  unVerifiedByInactivation?: Maybe<Scalars['Boolean']>;
  unitDictionaryEntryExternalUuid?: Maybe<Scalars['UUID']>;
  unitDictionaryEntryUnitName?: Maybe<Scalars['String']>;
  unitDictionaryEntryUnitNameUuid?: Maybe<Scalars['UUID']>;
  unitDictionaryEntryVersionUuid?: Maybe<Scalars['UUID']>;
  unitDictionaryStandardUnitName?: Maybe<Scalars['String']>;
  unitDictionaryStandardUnitNameUuid?: Maybe<Scalars['UUID']>;
  updated: Scalars['DateTime'];
  userValue?: Maybe<Scalars['String']>;
  variableDataFormat?: Maybe<Scalars['String']>;
  variableVersionUuid?: Maybe<Scalars['UUID']>;
  wasSigned: Scalars['Boolean'];
};

export type DataPointReviewStatusMessageItem = {
  __typename?: 'DataPointReviewStatusMessageItem';
  avroSize: Scalars['Long'];
  dataPointId?: Maybe<Scalars['Long']>;
  dataPointReviewStatusUuid: Scalars['UUID'];
  dataPointUuid: Scalars['UUID'];
  isReviewed: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  reviewGroupUuid: Scalars['UUID'];
};

export type DataPointUntranslatedMessageItem = {
  __typename?: 'DataPointUntranslatedMessageItem';
  avroSize: Scalars['Long'];
  dataPointId?: Maybe<Scalars['Long']>;
  dataPointUntranslatedUuid: Scalars['UUID'];
  dataPointUuid: Scalars['UUID'];
  locale: Scalars['String'];
  localeUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  untranslatedData: Scalars['String'];
};

export type DataVerificationHashJob = LegionJob & {
  __typename?: 'DataVerificationHashJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type DataVerificationHashJobCreatorJob = LegionJob & {
  __typename?: 'DataVerificationHashJobCreatorJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type DataVerificationHashJobCreatorTask = LegionTask & {
  __typename?: 'DataVerificationHashJobCreatorTask';
  attemptCount: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  endLsn: Scalars['String'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  startLsn: Scalars['String'];
  status: TaskItemStatus;
};

export type DataVerificationHashMessage = EventMessage & IEventMessage & {
  __typename?: 'DataVerificationHashMessage';
  body: DataVerificationHashMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type DataVerificationHashMessageBody = {
  __typename?: 'DataVerificationHashMessageBody';
  avroSize: Scalars['Long'];
  dataVerificationHashes: Array<DataVerificationHashMessageItem>;
  metadata: Metadata;
};

export type DataVerificationHashMessageItem = {
  __typename?: 'DataVerificationHashMessageItem';
  appVersion?: Maybe<Scalars['String']>;
  avroSize: Scalars['Long'];
  batchSize: Scalars['Int'];
  bucketId: Scalars['Long'];
  hashValue: Scalars['String'];
  includedRowCount: Scalars['Long'];
  lastUpdated: Scalars['DateTime'];
  objectName: Scalars['String'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  orderColumn: Scalars['String'];
};

export enum DataVerificationHashObject {
  ClinicalSignificances = 'CLINICAL_SIGNIFICANCES',
  CoderDecisions = 'CODER_DECISIONS',
  CoderValues = 'CODER_VALUES',
  CrfVersions = 'CRF_VERSIONS',
  DataDictionaries = 'DATA_DICTIONARIES',
  DataDictionaryEntries = 'DATA_DICTIONARY_ENTRIES',
  DataPages = 'DATA_PAGES',
  DataPoints = 'DATA_POINTS',
  DataPointReviewStatus = 'DATA_POINT_REVIEW_STATUS',
  DataPointUntranslated = 'DATA_POINT_UNTRANSLATED',
  Derivations = 'DERIVATIONS',
  DerivationSteps = 'DERIVATION_STEPS',
  Fields = 'FIELDS',
  FieldRestrictions = 'FIELD_RESTRICTIONS',
  FieldReviewGroups = 'FIELD_REVIEW_GROUPS',
  Folders = 'FOLDERS',
  FolderForms = 'FOLDER_FORMS',
  Forms = 'FORMS',
  FormRestrictions = 'FORM_RESTRICTIONS',
  Instances = 'INSTANCES',
  LocalizedDataStrings = 'LOCALIZED_DATA_STRINGS',
  LocalizedStrings = 'LOCALIZED_STRINGS',
  Markings = 'MARKINGS',
  Matrices = 'MATRICES',
  Records = 'RECORDS',
  SharedSubjects = 'SHARED_SUBJECTS',
  Signatures = 'SIGNATURES',
  Subjects = 'SUBJECTS',
  SubjectMatrices = 'SUBJECT_MATRICES',
  SubjectStatusHistories = 'SUBJECT_STATUS_HISTORIES',
  UnitDictionaries = 'UNIT_DICTIONARIES',
  UnitDictionaryEntries = 'UNIT_DICTIONARY_ENTRIES',
  Variables = 'VARIABLES'
}

export type DataVerificationHashRecalculationJob = LegionJob & {
  __typename?: 'DataVerificationHashRecalculationJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type DataVerificationHashRecalculationTask = LegionTask & {
  __typename?: 'DataVerificationHashRecalculationTask';
  attemptCount: Scalars['Int'];
  batchSize: Scalars['Int'];
  buckets: Array<Scalars['Long']>;
  dataVerificationHashObject?: Maybe<DataVerificationHashObject>;
  fromIdInclusive: Scalars['Long'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  toIdExclusive: Scalars['Long'];
};

export type DataVerificationHashTask = LegionTask & {
  __typename?: 'DataVerificationHashTask';
  attemptCount: Scalars['Int'];
  batchSize: Scalars['Int'];
  buckets: Array<Scalars['Long']>;
  createJsonFile: Scalars['Boolean'];
  dataVerificationHashObject?: Maybe<DataVerificationHashObject>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
};

export type DataVerificationHashTaskData = LegionTaskData & {
  __typename?: 'DataVerificationHashTaskData';
  bucketId: Scalars['Long'];
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  gridFsFileId: Scalars['String'];
  jobId: Scalars['UUID'];
  objectName: Scalars['String'];
  taskId: Scalars['UUID'];
};

export type DatabaseEnableUpdateInput = {
  /** Database id. */
  databaseId: Scalars['UUID'];
  /** True to enable database. */
  enabled: Scalars['Boolean'];
};

export type DatabaseEnableUpdatePayload = {
  __typename?: 'DatabaseEnableUpdatePayload';
  database?: Maybe<DatabaseMetadata>;
};

export type DatabaseMetadata = {
  __typename?: 'DatabaseMetadata';
  active: Scalars['Boolean'];
  appVersion: Scalars['String'];
  databaseId: Scalars['UUID'];
  databaseName?: Maybe<Scalars['String']>;
  databaseType: DatabaseTypeFlags;
  databaseVersion: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
  hostname: Scalars['String'];
  isClassic: Scalars['Boolean'];
  lastSyncTimeStamp: Scalars['DateTime'];
  raveUrl: Scalars['String'];
  sqlServerId: Scalars['UUID'];
  sqlServerName: Scalars['String'];
  studyGroupUuids: Array<Scalars['String']>;
  studyUuids: Array<Scalars['String']>;
};

export type DatabaseMetadataFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DatabaseMetadataFilterInput>>;
  appVersion?: InputMaybe<StringOperationFilterInput>;
  databaseId?: InputMaybe<UuidOperationFilterInput>;
  databaseName?: InputMaybe<StringOperationFilterInput>;
  databaseType?: InputMaybe<DatabaseTypeOperationFilterInput>;
  databaseVersion?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  hostname?: InputMaybe<StringOperationFilterInput>;
  isClassic?: InputMaybe<BooleanOperationFilterInput>;
  lastSyncTimeStamp?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DatabaseMetadataFilterInput>>;
  raveUrl?: InputMaybe<StringOperationFilterInput>;
  sqlServerId?: InputMaybe<UuidOperationFilterInput>;
  sqlServerName?: InputMaybe<StringOperationFilterInput>;
  studyGroupUuids?: InputMaybe<ListStringOperationFilterInput>;
  studyUuids?: InputMaybe<ListStringOperationFilterInput>;
};

export type DatabaseMetadataSortInput = {
  active?: InputMaybe<SortEnumType>;
  appVersion?: InputMaybe<SortEnumType>;
  databaseId?: InputMaybe<SortEnumType>;
  databaseName?: InputMaybe<SortEnumType>;
  databaseType?: InputMaybe<SortEnumType>;
  databaseVersion?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  hostname?: InputMaybe<SortEnumType>;
  isClassic?: InputMaybe<SortEnumType>;
  lastSyncTimeStamp?: InputMaybe<SortEnumType>;
  raveUrl?: InputMaybe<SortEnumType>;
  sqlServerId?: InputMaybe<SortEnumType>;
  sqlServerName?: InputMaybe<SortEnumType>;
};

export type DatabaseTypeFlags = {
  __typename?: 'DatabaseTypeFlags';
  isNone: Scalars['Boolean'];
  isStudy: Scalars['Boolean'];
  isStudyGroup: Scalars['Boolean'];
};

export type DatabaseTypeFlagsInput = {
  isNone?: InputMaybe<Scalars['Boolean']>;
  isStudy?: InputMaybe<Scalars['Boolean']>;
  isStudyGroup?: InputMaybe<Scalars['Boolean']>;
};

export type DatabaseTypeOperationFilterInput = {
  eq?: InputMaybe<DatabaseTypeFlagsInput>;
  in?: InputMaybe<Array<DatabaseTypeFlagsInput>>;
  neq?: InputMaybe<DatabaseTypeFlagsInput>;
  nin?: InputMaybe<Array<DatabaseTypeFlagsInput>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DecisionTerm = {
  __typename?: 'DecisionTerm';
  code: Scalars['String'];
  level: Scalars['String'];
  text: Scalars['String'];
};

export enum DeferredRollupOperation {
  DeleteRole = 'DELETE_ROLE',
  UpdateStatus = 'UPDATE_STATUS'
}

export type DeleteCustomConfigOverrideTagInput = {
  customConfigOverrideTag: Scalars['String'];
  databaseId: Scalars['UUID'];
};

export type DeleteCustomConfigOverrideTagPayload = {
  __typename?: 'DeleteCustomConfigOverrideTagPayload';
  isDeleted: Scalars['Boolean'];
};

export type DerivationDefinitionMessageItem = {
  __typename?: 'DerivationDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  derivationDefinitionUuid: Scalars['UUID'];
  derivationOid: Scalars['String'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
};

export type DerivationVersionMessageItem = {
  __typename?: 'DerivationVersionMessageItem';
  allVariablesInFields: Scalars['Boolean'];
  allVariablesInFolders: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  derivationDefinitionUuid: Scalars['UUID'];
  derivationName: Scalars['String'];
  derivationOid: Scalars['String'];
  derivationVersionUuid: Scalars['UUID'];
  fieldDefinitionUuid?: Maybe<Scalars['UUID']>;
  folderDefinitionUuid?: Maybe<Scalars['UUID']>;
  instanceRepeatNumber?: Maybe<Scalars['Int']>;
  isNotBatchRunnable: Scalars['Boolean'];
  isNotUploadRunnable: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  pageRepeatNumber?: Maybe<Scalars['Int']>;
  recordPosition?: Maybe<Scalars['Int']>;
};

export type DiagnosticOption = {
  __typename?: 'DiagnosticOption';
  diagnosticScript: DiagnosticType;
  name: Scalars['String'];
};

export type DiagnosticSortInput = {
  column: Scalars['String'];
  direction: SortType;
};

export enum DiagnosticType {
  BulkOperation = 'BULK_OPERATION',
  StatusRollup = 'STATUS_ROLLUP',
  StatusRollupProgress = 'STATUS_ROLLUP_PROGRESS'
}

/** A segment of a collection. */
export type DiagnosticsCollectionSegment = {
  __typename?: 'DiagnosticsCollectionSegment';
  columns: Array<Scalars['String']>;
  /** A flattened list of the items. */
  items?: Maybe<Array<LegionDiagnostic>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type EdcMessage = EventMessage & IEventMessage & {
  __typename?: 'EdcMessage';
  body: EdcMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type EdcMessageBody = {
  __typename?: 'EdcMessageBody';
  clinicalSignificances: Array<ClinicalSignificanceMessageItem>;
  coderDecisions: Array<CoderDecisionMessageItem>;
  coderValues: Array<CoderValueMessageItem>;
  dataPages: Array<DataPageMessageItem>;
  dataPointReviewStatuses: Array<DataPointReviewStatusMessageItem>;
  dataPoints: Array<DataPointMessageItem>;
  dataPointsUntranslated: Array<DataPointUntranslatedMessageItem>;
  instances: Array<InstanceMessageItem>;
  markings: Array<MarkingMessageItem>;
  metadata?: Maybe<EdcMetadata>;
  records: Array<RecordMessageItem>;
  sharedSubjects: Array<SharedSubjectMessageItem>;
  signatures: Array<SignatureMessageItem>;
  studies: Array<StudySupplementalItem>;
  studyEnvironmentSites: Array<StudyEnvironmentSiteSupplementalItem>;
  studyEnvironments: Array<StudyEnvironmentSupplementalItem>;
  subjectMatrices: Array<SubjectMatrixMessageItem>;
  subjectStatusHistories: Array<SubjectStatusHistoryMessageItem>;
  subjects: Array<SubjectMessageItem>;
};

export type EdcMetadata = {
  __typename?: 'EdcMetadata';
  _mdsol_lineage?: Maybe<Array<Array<KeyValuePairOfStringAndString>>>;
  _mdsol_timeliness?: Maybe<Array<KeyValuePairOfStringAndString>>;
  _mdsol_updated_at?: Maybe<Scalars['DateTime']>;
  defaultLocale?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  jobRequestId?: Maybe<Scalars['UUID']>;
  messageContentType?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['UUID']>;
  messageTime?: Maybe<Scalars['DateTime']>;
  multiMessageCount?: Maybe<Scalars['Int']>;
  multiMessageIndex?: Maybe<Scalars['Int']>;
  multiMessageUuid?: Maybe<Scalars['UUID']>;
  raveDatabaseVersion?: Maybe<Scalars['String']>;
  raveUrl?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  roleUuid?: Maybe<Scalars['UUID']>;
  studyEnvironment?: Maybe<Scalars['String']>;
  studyEnvironmentUuid?: Maybe<Scalars['UUID']>;
  studyGroupUuid?: Maybe<Scalars['UUID']>;
  studyUuid?: Maybe<Scalars['UUID']>;
  subjectUuid?: Maybe<Scalars['UUID']>;
  targetObjectType?: Maybe<Scalars['String']>;
  targetObjectUuid?: Maybe<Scalars['UUID']>;
  traceparent?: Maybe<Scalars['String']>;
  transactionEndTime?: Maybe<Scalars['DateTime']>;
  transactionId?: Maybe<Scalars['String']>;
  userLogin?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['UUID']>;
};

export type EnumMessage = EventMessage & IEventMessage & {
  __typename?: 'EnumMessage';
  body: EnumMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type EnumMessageBody = {
  __typename?: 'EnumMessageBody';
  actionTypes: Array<ActionTypeMessageItem>;
  auditCategories: Array<AuditCategoryMessageItem>;
  auditSubCategories: Array<AuditSubCategoryMessageItem>;
  avroSize: Scalars['Long'];
  impliedActionTypes: Array<ImpliedActionTypeMessageItem>;
  markingGroupCategories: Array<MarkingGroupCategoryMessageItem>;
  metadata?: Maybe<Metadata>;
  modules: Array<ModuleMessageItem>;
  objectTypes: Array<ObjectTypeMessageItem>;
  queryStatuses: Array<QueryStatusMessageItem>;
  subjectStatusCategories: Array<SubjectStatusCategoryMessageItem>;
};

export type EventMessage = {
  body: EventMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type EventMessageBody = ArchitectMessageBody | AuditMessageBody | CoderConfigMessageBody | ConfigurationMessageBody | CrfVersionMessageBody | DataVerificationHashMessageBody | EdcMessageBody | EnumMessageBody | InterimLockMessageBody | LocalizedDataStringMessageBody | LocalizedStringMessageBody | ObjectTagMessageBody | PlatformObjectMessageBody | RaveUserMessageBody | SyntheticDataMessageBody;

export type EventMessageTypeFlags = {
  __typename?: 'EventMessageTypeFlags';
  isApplication: Scalars['Boolean'];
  isArchitect: Scalars['Boolean'];
  isArchitectDataLoad: Scalars['Boolean'];
  isAuditDataLoad: Scalars['Boolean'];
  isAudits: Scalars['Boolean'];
  isCoderConfig: Scalars['Boolean'];
  isCoderConfigDataLoad: Scalars['Boolean'];
  isConfiguration: Scalars['Boolean'];
  isConfigurationDataLoad: Scalars['Boolean'];
  isCrfVersion: Scalars['Boolean'];
  isCrfVersionDataLoad: Scalars['Boolean'];
  isDataPointDataLoad: Scalars['Boolean'];
  isDataVerificationHash: Scalars['Boolean'];
  isDataVerificationHashDataLoad: Scalars['Boolean'];
  isEDC: Scalars['Boolean'];
  isEdcDataLoad: Scalars['Boolean'];
  isEnum: Scalars['Boolean'];
  isEnumDataLoad: Scalars['Boolean'];
  isInterimLock: Scalars['Boolean'];
  isLocalizedDataString: Scalars['Boolean'];
  isLocalizedDataStringDataLoad: Scalars['Boolean'];
  isLocalizedString: Scalars['Boolean'];
  isLocalizedStringDataLoad: Scalars['Boolean'];
  isObjectTag: Scalars['Boolean'];
  isObjectTagDataLoad: Scalars['Boolean'];
  isPlatformObject: Scalars['Boolean'];
  isPlatformObjectDataLoad: Scalars['Boolean'];
  isRaveUser: Scalars['Boolean'];
  isRaveUserDataLoad: Scalars['Boolean'];
  isShared: Scalars['Boolean'];
  isSyntheticData: Scalars['Boolean'];
  isUnknown: Scalars['Boolean'];
};

export type EventMessagingAuditDataLoadJob = LegionJob & {
  __typename?: 'EventMessagingAuditDataLoadJob';
  attemptCount: Scalars['Int'];
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  kafkaTopicUuid: Scalars['UUID'];
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type EventMessagingAuditDataLoadTask = LegionTask & {
  __typename?: 'EventMessagingAuditDataLoadTask';
  attemptCount: Scalars['Int'];
  fromId: Scalars['Long'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  toId: Scalars['Long'];
};

export type EventMessagingAuditJob = LegionJob & {
  __typename?: 'EventMessagingAuditJob';
  attemptCount: Scalars['Int'];
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type EventMessagingBulkSortTask = LegionTask & {
  __typename?: 'EventMessagingBulkSortTask';
  attemptCount: Scalars['Int'];
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  endLsn: Scalars['String'];
  eventMessageType: EventMessageTypeFlags;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  objectId?: Maybe<Scalars['Long']>;
  objectUuid?: Maybe<Scalars['UUID']>;
  partitionKey: Scalars['String'];
  startLsn: Scalars['String'];
  status: TaskItemStatus;
};

export type EventMessagingChangeDataDataLoadTaskData = LegionTaskData & {
  __typename?: 'EventMessagingChangeDataDataLoadTaskData';
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  dataPointIds: Array<Scalars['Long']>;
  jobId: Scalars['UUID'];
  subjectId: Scalars['Long'];
  taskId: Scalars['UUID'];
};

export type EventMessagingDataLoadJob = LegionJob & {
  __typename?: 'EventMessagingDataLoadJob';
  attemptCount: Scalars['Int'];
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  kafkaTopicUuid: Scalars['UUID'];
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type EventMessagingDataLoadTask = LegionTask & {
  __typename?: 'EventMessagingDataLoadTask';
  attemptCount: Scalars['Int'];
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  eventMessageType: EventMessageTypeFlags;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  objectId?: Maybe<Scalars['Long']>;
  objectUuid?: Maybe<Scalars['UUID']>;
  partitionKey: Scalars['String'];
  secondaryObjectIds: Array<Scalars['Long']>;
  status: TaskItemStatus;
};

export type EventMessagingSendJob = LegionJob & {
  __typename?: 'EventMessagingSendJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  kafkaTopicUuid: Scalars['UUID'];
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  messageType: EventMessageTypeFlags;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  sentMessagesCount: Scalars['Int'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type EventMessagingSendTask = LegionTask & {
  __typename?: 'EventMessagingSendTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  message: IEventMessage;
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
};

export type EventMessagingSendTaskData = LegionTaskData & {
  __typename?: 'EventMessagingSendTaskData';
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  jobId: Scalars['UUID'];
  message: IEventMessage;
  taskId: Scalars['UUID'];
};

export type EventMessagingSortJob = LegionJob & {
  __typename?: 'EventMessagingSortJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type EventMessagingSortTask = LegionTask & {
  __typename?: 'EventMessagingSortTask';
  attemptCount: Scalars['Int'];
  endLsn: Scalars['String'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  startLsn: Scalars['String'];
  status: TaskItemStatus;
};

export type ExternalUserMessageItem = {
  __typename?: 'ExternalUserMessageItem';
  avroSize: Scalars['Long'];
  email?: Maybe<Scalars['String']>;
  externalId: Scalars['Int'];
  externalUserId?: Maybe<Scalars['Long']>;
  externalUserUuid: Scalars['UUID'];
  lastExternalUpdateDate?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
};

export type FeatureFlagStatus = {
  __typename?: 'FeatureFlagStatus';
  name: Scalars['String'];
  status: FeatureStatus;
};

export type FeatureFlagUpdateInput = {
  databaseId: Scalars['UUID'];
  name: Scalars['String'];
  status: FeatureStatus;
};

export type FeatureFlagUpdatePayload = {
  __typename?: 'FeatureFlagUpdatePayload';
  database?: Maybe<DatabaseMetadata>;
};

export enum FeatureStatus {
  Enable = 'ENABLE',
  Off = 'OFF',
  Pause = 'PAUSE'
}

export type FieldDefinitionMessageItem = {
  __typename?: 'FieldDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  fieldDefinitionUuid: Scalars['UUID'];
  fieldOid?: Maybe<Scalars['String']>;
  formDefinitionUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
};

export type FieldVersionMessageItem = {
  __typename?: 'FieldVersionMessageItem';
  acceptableFileExtensions?: Maybe<Scalars['String']>;
  analyteUuid?: Maybe<Scalars['UUID']>;
  attributeUri?: Maybe<Scalars['String']>;
  avroSize: Scalars['Long'];
  canSetDataPageDate: Scalars['Boolean'];
  canSetInstanceDate: Scalars['Boolean'];
  canSetRecordDate: Scalars['Boolean'];
  canSetSubjectDate: Scalars['Boolean'];
  componentAppOid?: Maybe<Scalars['String']>;
  componentName?: Maybe<Scalars['String']>;
  componentUuid?: Maybe<Scalars['String']>;
  conceptUri?: Maybe<Scalars['String']>;
  controlType?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  defaultValue?: Maybe<Scalars['String']>;
  doesNotBreakSignature: Scalars['Boolean'];
  draftDomainId?: Maybe<Scalars['Int']>;
  eproFormat?: Maybe<Scalars['String']>;
  fieldDefinitionUuid: Scalars['UUID'];
  fieldName?: Maybe<Scalars['String']>;
  fieldNameUuid?: Maybe<Scalars['UUID']>;
  fieldNumberId?: Maybe<Scalars['Int']>;
  fieldVersionUuid: Scalars['UUID'];
  formDefinitionUuid: Scalars['UUID'];
  headerText?: Maybe<Scalars['String']>;
  headerTextUuid?: Maybe<Scalars['UUID']>;
  helpText?: Maybe<Scalars['String']>;
  helpTextUuid?: Maybe<Scalars['UUID']>;
  indentLevel: Scalars['Byte'];
  isChild?: Maybe<Scalars['Boolean']>;
  isClinicalSignificance?: Maybe<Scalars['Boolean']>;
  isFormatMatched?: Maybe<Scalars['Boolean']>;
  isFutureDateTime?: Maybe<Scalars['Boolean']>;
  isLog?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  isVisualVerify: Scalars['Boolean'];
  lowerRange?: Maybe<Scalars['String']>;
  ncLowerRange?: Maybe<Scalars['String']>;
  ncUpperRange?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  otherVisits: Scalars['Boolean'];
  postText?: Maybe<Scalars['String']>;
  postTextUuid?: Maybe<Scalars['UUID']>;
  preText?: Maybe<Scalars['String']>;
  preTextUuid?: Maybe<Scalars['UUID']>;
  requiresTranslation: Scalars['Boolean'];
  sasFormat?: Maybe<Scalars['String']>;
  sasLabel?: Maybe<Scalars['String']>;
  sourceDocument: Scalars['Boolean'];
  upperRange?: Maybe<Scalars['String']>;
};

export type FolderDefinitionMessageItem = {
  __typename?: 'FolderDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  folderDefinitionUuid: Scalars['UUID'];
  folderOid: Scalars['String'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
};

export type FolderVersionMessageItem = {
  __typename?: 'FolderVersionMessageItem';
  accessDays?: Maybe<Scalars['Int']>;
  avroSize: Scalars['Long'];
  closeDays?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  endWinDays?: Maybe<Scalars['Int']>;
  folderDefinitionUuid: Scalars['UUID'];
  folderName: Scalars['String'];
  folderNameUuid: Scalars['UUID'];
  folderVersionUuid: Scalars['UUID'];
  isReusable: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  overdueDays?: Maybe<Scalars['Int']>;
  parentFolderDefinitionUuid?: Maybe<Scalars['UUID']>;
  startWinDays?: Maybe<Scalars['Int']>;
  targetDays?: Maybe<Scalars['Int']>;
};

export type FormDefinitionMessageItem = {
  __typename?: 'FormDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  formDefinitionUuid: Scalars['UUID'];
  formOid?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
};

export type FormVersionMessageItem = {
  __typename?: 'FormVersionMessageItem';
  allowLogAdd: Scalars['Boolean'];
  allowLogInactivate: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  confirmationStyle?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  ddeOption: Scalars['Int'];
  editDirection: Scalars['Boolean'];
  formDefinitionUuid: Scalars['UUID'];
  formName?: Maybe<Scalars['String']>;
  formNameUuid: Scalars['UUID'];
  formVersionUuid: Scalars['UUID'];
  helpText?: Maybe<Scalars['String']>;
  helpTextUuid?: Maybe<Scalars['UUID']>;
  isEproForm: Scalars['Boolean'];
  isQuestionnaire: Scalars['Boolean'];
  isSignatureRequired?: Maybe<Scalars['Boolean']>;
  isTemplate: Scalars['Boolean'];
  layout: Scalars['Int'];
  linkFolderOID?: Maybe<Scalars['String']>;
  linkFormOID?: Maybe<Scalars['String']>;
  maxLogs?: Maybe<Scalars['Int']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  startLogs?: Maybe<Scalars['Int']>;
};

export type IEventMessage = {
  body: EventMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type ImpliedActionTypeMessageItem = {
  __typename?: 'ImpliedActionTypeMessageItem';
  actionTypeId: Scalars['Int'];
  actionTypeName: Scalars['String'];
  avroSize: Scalars['Long'];
  impliedActionTypeId: Scalars['Int'];
  impliedActionTypeName: Scalars['String'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
};

export type InstanceMessageItem = {
  __typename?: 'InstanceMessageItem';
  access?: Maybe<Scalars['DateTime']>;
  avroSize: Scalars['Long'];
  balanceVisitIdentifier?: Maybe<Scalars['UUID']>;
  close?: Maybe<Scalars['DateTime']>;
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  endWin?: Maybe<Scalars['DateTime']>;
  folderExternalUuid?: Maybe<Scalars['UUID']>;
  folderName?: Maybe<Scalars['String']>;
  folderNameUuid?: Maybe<Scalars['UUID']>;
  folderOid: Scalars['String'];
  folderVersionUuid: Scalars['UUID'];
  instanceActive: Scalars['Boolean'];
  instanceDate?: Maybe<Scalars['DateTime']>;
  instanceId?: Maybe<Scalars['Long']>;
  instanceName: Scalars['String'];
  instanceRepeatNumber: Scalars['Int'];
  instanceUuid: Scalars['UUID'];
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  objectTagOids?: Maybe<Array<Scalars['String']>>;
  objectTagUuids?: Maybe<Array<Scalars['UUID']>>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  overdue?: Maybe<Scalars['DateTime']>;
  parentInstanceUuid?: Maybe<Scalars['UUID']>;
  reasonDescription?: Maybe<Scalars['String']>;
  reasonDescriptionUuid?: Maybe<Scalars['UUID']>;
  requiresSignature?: Maybe<Scalars['Boolean']>;
  startWin?: Maybe<Scalars['DateTime']>;
  subjectMatrixUuid?: Maybe<Scalars['UUID']>;
  subjectUuid: Scalars['UUID'];
  target?: Maybe<Scalars['DateTime']>;
  updated: Scalars['DateTime'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export enum InterimLockActionType {
  Freeze = 'FREEZE',
  Lock = 'LOCK',
  UnFreeze = 'UN_FREEZE',
  UnLock = 'UN_LOCK'
}

export type InterimLockDataPageMessageItem = {
  __typename?: 'InterimLockDataPageMessageItem';
  avroSize: Scalars['Long'];
  dataPageUuid: Scalars['UUID'];
  folderNameUuid?: Maybe<Scalars['UUID']>;
  folderOid?: Maybe<Scalars['String']>;
  folderUuid?: Maybe<Scalars['UUID']>;
  formNameUuid: Scalars['UUID'];
  formOid: Scalars['String'];
  formUuid: Scalars['UUID'];
  instanceUuid?: Maybe<Scalars['UUID']>;
  locales: Array<InterimLockLocaleMessageItem>;
  patientName: Scalars['String'];
  patientSecondaryName: Scalars['String'];
  patientUuid: Scalars['UUID'];
  records: Array<InterimLockRecordMessageItem>;
  studyEnvironmentSiteUuid: Scalars['UUID'];
};

export enum InterimLockFilterOperation {
  DateAfter = 'DATE_AFTER',
  DateBefore = 'DATE_BEFORE',
  DateBetween = 'DATE_BETWEEN',
  DateEqual = 'DATE_EQUAL',
  DateIn = 'DATE_IN',
  NumberBetween = 'NUMBER_BETWEEN',
  NumberEqual = 'NUMBER_EQUAL',
  NumberGreaterThan = 'NUMBER_GREATER_THAN',
  NumberIn = 'NUMBER_IN',
  NumberLessThan = 'NUMBER_LESS_THAN',
  TextEqual = 'TEXT_EQUAL',
  TextIn = 'TEXT_IN',
  TextNotEmpty = 'TEXT_NOT_EMPTY'
}

export type InterimLockInput = {
  __typename?: 'InterimLockInput';
  action: InterimLockActionType;
  logLines?: Maybe<Array<InterimLockInputLogLine>>;
  patientFilter?: Maybe<InterimLockInputPatientFilter>;
  roleId: Scalars['Int'];
  studyEnvironmentSiteUuids?: Maybe<Array<Scalars['UUID']>>;
  studyId: Scalars['Int'];
  userId: Scalars['Int'];
  visitExcludedFormOids?: Maybe<Array<Scalars['String']>>;
  visitFilter?: Maybe<InterimLockInputVisitFilter>;
  visitIncludedFolderOids: Array<Scalars['String']>;
};

export type InterimLockInputLogLine = {
  __typename?: 'InterimLockInputLogLine';
  action: InterimLockLogLineActionType;
  filter?: Maybe<InterimLockInputLogLineFilter>;
  folderOid: Scalars['String'];
  formOid: Scalars['String'];
};

export type InterimLockInputLogLineFilter = {
  __typename?: 'InterimLockInputLogLineFilter';
  data?: Maybe<Array<Scalars['String']>>;
  fieldOid: Scalars['String'];
  operation: InterimLockFilterOperation;
};

export type InterimLockInputPatientFilter = {
  __typename?: 'InterimLockInputPatientFilter';
  data?: Maybe<Array<Scalars['String']>>;
  fieldOid: Scalars['String'];
  folderOid: Scalars['String'];
  formOid: Scalars['String'];
  operation: InterimLockFilterOperation;
};

export type InterimLockInputVisitFilter = {
  __typename?: 'InterimLockInputVisitFilter';
  data?: Maybe<Array<Scalars['String']>>;
  fieldOid: Scalars['String'];
  formOid: Scalars['String'];
  operation: InterimLockFilterOperation;
};

export type InterimLockJob = LegionJob & {
  __typename?: 'InterimLockJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  input: InterimLockInput;
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  roleId: Scalars['Int'];
  status: JobStatus;
  studyId: Scalars['Int'];
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  totalDataPages: Scalars['Int'];
  totalPatients: Scalars['Int'];
  totalRecords: Scalars['Int'];
  totalTasks: Scalars['Int'];
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
  type: InterimLockActionType;
  userId: Scalars['Int'];
};

export type InterimLockLocaleMessageItem = {
  __typename?: 'InterimLockLocaleMessageItem';
  avroSize: Scalars['Long'];
  dataPageName: Scalars['String'];
  default: Scalars['Boolean'];
  instanceName?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  siteName: Scalars['String'];
};

export enum InterimLockLogLineActionType {
  Freeze = 'FREEZE',
  LockEntirePage = 'LOCK_ENTIRE_PAGE',
  LockEntirePageExceptLastLogLine = 'LOCK_ENTIRE_PAGE_EXCEPT_LAST_LOG_LINE',
  LockEntirePageThenAddBlankLogLine = 'LOCK_ENTIRE_PAGE_THEN_ADD_BLANK_LOG_LINE',
  UnlockEntirePage = 'UNLOCK_ENTIRE_PAGE',
  UnlockLastLogLineOnly = 'UNLOCK_LAST_LOG_LINE_ONLY',
  UnFreeze = 'UN_FREEZE'
}

export type InterimLockMessage = EventMessage & IEventMessage & {
  __typename?: 'InterimLockMessage';
  body: InterimLockMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type InterimLockMessageBody = {
  __typename?: 'InterimLockMessageBody';
  completed: Scalars['Int'];
  dataPages: Array<InterimLockDataPageMessageItem>;
  failed: Scalars['Int'];
  metadata: InterimLockMetadata;
  partiallyCompleted: Scalars['Int'];
  preconditionFailed: Scalars['Int'];
  skipped: Scalars['Int'];
  taskNumber: Scalars['Int'];
  taskUuid: Scalars['UUID'];
  total: Scalars['Int'];
};

export type InterimLockMetadata = {
  __typename?: 'InterimLockMetadata';
  dataPageCount: Scalars['Int'];
  patientCount: Scalars['Int'];
  raveUrl?: Maybe<Scalars['String']>;
  recordCount: Scalars['Int'];
  requestUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
  taskCount: Scalars['Int'];
};

export type InterimLockRecordMessageItem = {
  __typename?: 'InterimLockRecordMessageItem';
  avroSize: Scalars['Long'];
  dataStatus: StatusesFlags;
  errorMessage?: Maybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  modifiedDataPointCount: Scalars['Int'];
  preconditionFailed: Scalars['Boolean'];
  processed: Scalars['Boolean'];
  recordPosition: Scalars['Int'];
  recordUuid: Scalars['UUID'];
  status: InterimLockStatus;
  totalDataPointCount: Scalars['Int'];
};

export type InterimLockRecordResult = {
  __typename?: 'InterimLockRecordResult';
  dataPageId: Scalars['Int'];
  dataStatus: StatusesFlags;
  errorMessage?: Maybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  modifiedDataPointCount: Scalars['Int'];
  preconditionFailed: Scalars['Boolean'];
  processed: Scalars['Boolean'];
  recordId: Scalars['Int'];
  recordPosition: Scalars['Int'];
  recordUuid: Scalars['UUID'];
  status: InterimLockStatus;
  totalDataPointCount: Scalars['Int'];
};

export enum InterimLockStatus {
  Error = 'ERROR',
  None = 'NONE',
  PartialSuccess = 'PARTIAL_SUCCESS',
  PreConditionFailed = 'PRE_CONDITION_FAILED',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS'
}

export type InterimLockTask = LegionTask & {
  __typename?: 'InterimLockTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  recordIds: Array<Scalars['Int']>;
  status: TaskItemStatus;
  subjectId: Scalars['Int'];
  taskNumber: Scalars['Int'];
};

export type InterimLockTaskData = LegionTaskData & {
  __typename?: 'InterimLockTaskData';
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  jobId: Scalars['UUID'];
  results?: Maybe<Array<InterimLockRecordResult>>;
  taskId: Scalars['UUID'];
};

export type InternalUserMessageItem = {
  __typename?: 'InternalUserMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  externalUserId: Scalars['Long'];
  internalUserUuid: Scalars['UUID'];
  localization?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
  userActive: Scalars['Boolean'];
  userId?: Maybe<Scalars['Long']>;
};

export type JobCreatorOptions = {
  __typename?: 'JobCreatorOptions';
  category: JobRequestCategory;
  categoryName: Scalars['String'];
  enableChangesAfterDate: Scalars['Boolean'];
  enableDataVerificationHashObject: Scalars['Boolean'];
  enableKafkaTopic: Scalars['Boolean'];
  enableMultipleUrlSelection: Scalars['Boolean'];
  enableObjectId: Scalars['Boolean'];
  enableStudy: Scalars['Boolean'];
  enableStudyEnvironment: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  isStudyRequired: Scalars['Boolean'];
  kafkaTopics: Array<KafkaTopicState>;
};

export type JobRequest = {
  __typename?: 'JobRequest';
  category: JobRequestCategory;
  categoryName: Scalars['String'];
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  completedJobCount: Scalars['Int'];
  created: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  jobCompletedTime?: Maybe<Scalars['DateTime']>;
  jobCount: Scalars['Int'];
  objectId?: Maybe<Scalars['String']>;
  requestId: Scalars['UUID'];
  sentMessageCount: Scalars['Int'];
  status?: Maybe<JobRequestStatus>;
  studyName?: Maybe<Scalars['String']>;
  studyUuid?: Maybe<Scalars['UUID']>;
  url: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export enum JobRequestCategory {
  All = 'ALL',
  Architect = 'ARCHITECT',
  Audit = 'AUDIT',
  CleaningEngine = 'CLEANING_ENGINE',
  Clinical = 'CLINICAL',
  CoderConfig = 'CODER_CONFIG',
  Configuration = 'CONFIGURATION',
  ConfigurationOption = 'CONFIGURATION_OPTION',
  CrfVersion = 'CRF_VERSION',
  DataVerificationHash = 'DATA_VERIFICATION_HASH',
  DataVerificationHashRecalculation = 'DATA_VERIFICATION_HASH_RECALCULATION',
  DataVerificationHashWithJson = 'DATA_VERIFICATION_HASH_WITH_JSON',
  Enum = 'ENUM',
  InterimLock = 'INTERIM_LOCK',
  LocalizedDataString = 'LOCALIZED_DATA_STRING',
  LocalizedString = 'LOCALIZED_STRING',
  ObjectTag = 'OBJECT_TAG',
  PlatformObject = 'PLATFORM_OBJECT',
  RaveUser = 'RAVE_USER',
  StatusRollupPrioritization = 'STATUS_ROLLUP_PRIORITIZATION',
  TaskSummary = 'TASK_SUMMARY',
  TaskSummaryRecalculation = 'TASK_SUMMARY_RECALCULATION',
  TaskSummaryValidation = 'TASK_SUMMARY_VALIDATION'
}

export type JobRequestCategoryOperationFilterInput = {
  eq?: InputMaybe<JobRequestCategory>;
  in?: InputMaybe<Array<JobRequestCategory>>;
  neq?: InputMaybe<JobRequestCategory>;
  nin?: InputMaybe<Array<JobRequestCategory>>;
};

export type JobRequestFilterInput = {
  and?: InputMaybe<Array<JobRequestFilterInput>>;
  category?: InputMaybe<JobRequestCategoryOperationFilterInput>;
  categoryName?: InputMaybe<StringOperationFilterInput>;
  changesAfterDate?: InputMaybe<DateTimeOperationFilterInput>;
  completedJobCount?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  databaseId?: InputMaybe<UuidOperationFilterInput>;
  jobCompletedTime?: InputMaybe<DateTimeOperationFilterInput>;
  jobCount?: InputMaybe<IntOperationFilterInput>;
  objectId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobRequestFilterInput>>;
  requestId?: InputMaybe<UuidOperationFilterInput>;
  sentMessageCount?: InputMaybe<IntOperationFilterInput>;
  studyUuid?: InputMaybe<UuidOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type JobRequestInput = {
  category: JobRequestCategory;
  changesAfterDate?: InputMaybe<Scalars['DateTime']>;
  configuration?: InputMaybe<ConfigurationOptionValueInput>;
  dataVerificationHashObject?: InputMaybe<DataVerificationHashObject>;
  databaseIds: Array<Scalars['UUID']>;
  kafkaTopicUuid?: InputMaybe<Scalars['UUID']>;
  objectId?: InputMaybe<Scalars['String']>;
  studyId?: InputMaybe<Scalars['Int']>;
  studyUuid?: InputMaybe<Scalars['UUID']>;
};

export type JobRequestPayload = {
  __typename?: 'JobRequestPayload';
  requests: Array<JobRequest>;
};

export type JobRequestSortInput = {
  category?: InputMaybe<SortEnumType>;
  categoryName?: InputMaybe<SortEnumType>;
  changesAfterDate?: InputMaybe<SortEnumType>;
  completedJobCount?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  databaseId?: InputMaybe<SortEnumType>;
  jobCompletedTime?: InputMaybe<SortEnumType>;
  jobCount?: InputMaybe<SortEnumType>;
  objectId?: InputMaybe<SortEnumType>;
  requestId?: InputMaybe<SortEnumType>;
  sentMessageCount?: InputMaybe<SortEnumType>;
  studyUuid?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

export type JobRequestStatus = {
  __typename?: 'JobRequestStatus';
  completed: Scalars['Int'];
  enqueued: Scalars['Int'];
  failed: Scalars['Int'];
  finalError: Scalars['Int'];
  inProgress: Scalars['Int'];
  jobCompletedTime?: Maybe<Scalars['DateTime']>;
  notStarted: Scalars['Int'];
  total: Scalars['Int'];
};

export type JobRequesterJob = LegionJob & {
  __typename?: 'JobRequesterJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  /** This is Rave Study equivalent to Platform StudyEnvironment. */
  studyId?: Maybe<Scalars['Int']>;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type JobRequesterTask = LegionTask & {
  __typename?: 'JobRequesterTask';
  attemptCount: Scalars['Int'];
  category: JobRequestCategory;
  changesAfterDate?: Maybe<Scalars['DateTime']>;
  cleaningEngineRequests?: Maybe<Array<CleaningEngineRequest>>;
  configuration?: Maybe<ConfigurationOptionValue>;
  dataVerificationHashObject?: Maybe<DataVerificationHashObject>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  interimLock?: Maybe<InterimLockInput>;
  kafkaTopicUuid?: Maybe<Scalars['UUID']>;
  lastProcessedOn: Scalars['DateTime'];
  objectId?: Maybe<Scalars['String']>;
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  studyUuid?: Maybe<Scalars['UUID']>;
};

/** A connection to a list of items. */
export type JobRequestsConnection = {
  __typename?: 'JobRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JobRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<JobRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type JobRequestsEdge = {
  __typename?: 'JobRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: JobRequest;
};

export type JobRescheduleInput = {
  jobIds: Array<Scalars['UUID']>;
};

export type JobReschedulePayload = {
  __typename?: 'JobReschedulePayload';
  successful: Scalars['Boolean'];
};

export enum JobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Enqueued = 'ENQUEUED',
  Failed = 'FAILED',
  FinalError = 'FINAL_ERROR',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Skipped = 'SKIPPED'
}

export type JobStatusMetric = {
  __typename?: 'JobStatusMetric';
  count: Scalars['Int'];
  status: JobStatus;
};

export type JobStatusOperationFilterInput = {
  eq?: InputMaybe<JobStatus>;
  in?: InputMaybe<Array<JobStatus>>;
  neq?: InputMaybe<JobStatus>;
  nin?: InputMaybe<Array<JobStatus>>;
};

export enum JobType {
  BulkOperation = 'BULK_OPERATION',
  CodingDecision = 'CODING_DECISION',
  CrfVersion = 'CRF_VERSION',
  CvRefreshPopReportingRecords = 'CV_REFRESH_POP_REPORTING_RECORDS',
  CvRefreshTaskCreation = 'CV_REFRESH_TASK_CREATION',
  DataVerificationHasher = 'DATA_VERIFICATION_HASHER',
  DataVerificationHashJobCreator = 'DATA_VERIFICATION_HASH_JOB_CREATOR',
  DataVerificationHashRecalculation = 'DATA_VERIFICATION_HASH_RECALCULATION',
  EventMessagingAudit = 'EVENT_MESSAGING_AUDIT',
  EventMessagingAuditDataLoader = 'EVENT_MESSAGING_AUDIT_DATA_LOADER',
  EventMessagingChangeDataDataLoader = 'EVENT_MESSAGING_CHANGE_DATA_DATA_LOADER',
  EventMessagingDataLoader = 'EVENT_MESSAGING_DATA_LOADER',
  EventMessagingSender = 'EVENT_MESSAGING_SENDER',
  EventMessagingSorter = 'EVENT_MESSAGING_SORTER',
  InterimLock = 'INTERIM_LOCK',
  JobRequester = 'JOB_REQUESTER',
  LabQueue = 'LAB_QUEUE',
  NotificationCenter = 'NOTIFICATION_CENTER',
  ScriptUtility = 'SCRIPT_UTILITY',
  StatusRollup = 'STATUS_ROLLUP',
  SyntheticData = 'SYNTHETIC_DATA',
  TaskSummary = 'TASK_SUMMARY',
  TaskSummaryRecalculation = 'TASK_SUMMARY_RECALCULATION',
  TaskSummaryValidation = 'TASK_SUMMARY_VALIDATION',
  TsdvComputeSubjectsReadyToAllocate = 'TSDV_COMPUTE_SUBJECTS_READY_TO_ALLOCATE',
  TsdvRetrospective = 'TSDV_RETROSPECTIVE',
  Unknown = 'UNKNOWN'
}

export type JobTypeActionConfiguration = {
  __typename?: 'JobTypeActionConfiguration';
  jobStatus: Array<JobStatus>;
  jobType: JobType;
};

export type JobTypeActionOptions = {
  __typename?: 'JobTypeActionOptions';
  actionType: ActionType;
  configuration: Array<JobTypeActionConfiguration>;
  icon: Scalars['String'];
};

export type JobTypeMetric = {
  __typename?: 'JobTypeMetric';
  count: Scalars['Int'];
  jobType: JobType;
};

export type JobTypeOperationFilterInput = {
  eq?: InputMaybe<JobType>;
  in?: InputMaybe<Array<JobType>>;
  neq?: InputMaybe<JobType>;
  nin?: InputMaybe<Array<JobType>>;
};

export type JobTypeOption = {
  __typename?: 'JobTypeOption';
  categories?: Maybe<Array<JobRequestCategory>>;
  enableFeatureFlagName: Scalars['String'];
  jobType: JobType;
  overrides: Array<Scalars['String']>;
  pauseFeatureFlagName: Scalars['String'];
};

/** A connection to a list of items. */
export type JobsConnection = {
  __typename?: 'JobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LegionJob>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type JobsEdge = {
  __typename?: 'JobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: LegionJob;
};

export type KafkaConfigurationState = {
  __typename?: 'KafkaConfigurationState';
  brokers: Scalars['String'];
  enableDebugLogs: Scalars['Boolean'];
  enableSsl: Scalars['Boolean'];
  kafkaConfigurationId: Scalars['UUID'];
  name: Scalars['String'];
  saslMechanism: Scalars['String'];
  saslUsername: Scalars['String'];
  schemaRegistryHostname: Scalars['String'];
  type: Scalars['String'];
};

export type KafkaTopicState = {
  __typename?: 'KafkaTopicState';
  allowChangeData: Scalars['Boolean'];
  kafkaConfiguration: KafkaConfigurationState;
  kafkaConfigurationUuid: Scalars['UUID'];
  kafkaTopicName: Scalars['String'];
  messageType: Scalars['String'];
  name: Scalars['String'];
  numberOfPartitions: Scalars['Int'];
  replicationFactor: Scalars['Short'];
  topicUuid: Scalars['UUID'];
  type: Scalars['String'];
};

export type KeyValuePairOfStringAndListOfString = {
  __typename?: 'KeyValuePairOfStringAndListOfString';
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValuePairOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type LabClinicalSignificanceMessageItem = {
  __typename?: 'LabClinicalSignificanceMessageItem';
  avroSize: Scalars['Long'];
  clinicalSignificanceCode?: Maybe<ClinicalSignificanceCodeMessageItem>;
  clinicalSignificanceUuid: Scalars['UUID'];
  comment?: Maybe<Scalars['String']>;
  operationType: OperationType;
  updated?: Maybe<Scalars['DateTime']>;
};

export type LabData = {
  __typename?: 'LabData';
  alertRange?: Maybe<AnalyteRangeMessageItem>;
  analyteRange?: Maybe<AnalyteRangeMessageItem>;
  avroSize: Scalars['Long'];
  clinicalSignificance?: Maybe<LabClinicalSignificanceMessageItem>;
  dataPointUuid: Scalars['UUID'];
  labStandardGroup?: Maybe<LabStandardGroupMessageItem>;
  labUnit?: Maybe<LabUnitMessageItem>;
  operationType: OperationType;
  referenceRange?: Maybe<AnalyteRangeMessageItem>;
  standardHighRange: Scalars['Float'];
  standardLabUnitName?: Maybe<Scalars['String']>;
  standardLabUnitNameUuid?: Maybe<Scalars['UUID']>;
  standardLabUnitUuid?: Maybe<Scalars['UUID']>;
  standardLowRange: Scalars['Float'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type LabMessageItem = {
  __typename?: 'LabMessageItem';
  avroSize: Scalars['Long'];
  labName?: Maybe<Scalars['String']>;
  labNameUuid?: Maybe<Scalars['UUID']>;
  labTypeId: Scalars['Int'];
  labUuid: Scalars['UUID'];
  operationType: OperationType;
  rangeTypeName: Scalars['String'];
  rangeTypeUuid: Scalars['UUID'];
  rangesApproved?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type LabQueueJob = LegionJob & {
  __typename?: 'LabQueueJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type LabQueueLegionTask = LegionTask & {
  __typename?: 'LabQueueLegionTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  labUpdateQueueId: Scalars['Int'];
  lastProcessedOn: Scalars['DateTime'];
  objectId: Scalars['Int'];
  objectName: Scalars['String'];
  objectTypeId: Scalars['Int'];
  partitionKey: Scalars['String'];
  rangeValueChanged: Scalars['Boolean'];
  status: TaskItemStatus;
};

export type LabStandardGroupMessageItem = {
  __typename?: 'LabStandardGroupMessageItem';
  avroSize: Scalars['Long'];
  labStandardGroupName: Scalars['String'];
  labStandardGroupUuid: Scalars['UUID'];
  operationType: OperationType;
  updated?: Maybe<Scalars['DateTime']>;
};

export type LabUnitConversionMessageItem = {
  __typename?: 'LabUnitConversionMessageItem';
  analyteUuid?: Maybe<Scalars['UUID']>;
  avroSize: Scalars['Long'];
  constantA?: Maybe<Scalars['String']>;
  constantB?: Maybe<Scalars['String']>;
  constantC?: Maybe<Scalars['String']>;
  constantK?: Maybe<Scalars['String']>;
  labUnitConversionFromUuid: Scalars['UUID'];
  labUnitConversionToUuid: Scalars['UUID'];
  labUnitConversionUuid: Scalars['UUID'];
  operationType: OperationType;
  updated?: Maybe<Scalars['DateTime']>;
};

export type LabUnitMessageItem = {
  __typename?: 'LabUnitMessageItem';
  avroSize: Scalars['Long'];
  labUnitConversion?: Maybe<LabUnitConversionMessageItem>;
  labUnitConversionUuid?: Maybe<Scalars['UUID']>;
  labUnitName: Scalars['String'];
  labUnitNameUuid: Scalars['UUID'];
  labUnitUuid: Scalars['UUID'];
  operationType: OperationType;
  updated?: Maybe<Scalars['DateTime']>;
};

export type LegionDiagnostic = {
  data?: Maybe<Scalars['Any']>;
  id: Scalars['String'];
};

export type LegionJob = {
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type LegionJobFilterInput = {
  and?: InputMaybe<Array<LegionJobFilterInput>>;
  attemptCount?: InputMaybe<IntOperationFilterInput>;
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  databaseId?: InputMaybe<UuidOperationFilterInput>;
  enqueueTime?: InputMaybe<DateTimeOperationFilterInput>;
  hostname?: InputMaybe<StringOperationFilterInput>;
  jobId?: InputMaybe<UuidOperationFilterInput>;
  jobType?: InputMaybe<JobTypeOperationFilterInput>;
  lastProcessTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LegionJobFilterInput>>;
  originationTime?: InputMaybe<DateTimeOperationFilterInput>;
  partitionGroup?: InputMaybe<StringOperationFilterInput>;
  priority?: InputMaybe<IntOperationFilterInput>;
  raveUrl?: InputMaybe<StringOperationFilterInput>;
  requestId?: InputMaybe<UuidOperationFilterInput>;
  status?: InputMaybe<JobStatusOperationFilterInput>;
  tasks?: InputMaybe<ListFilterInputTypeOfLegionTaskFilterInput>;
  traceHeaders?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput>;
};

export type LegionJobSortInput = {
  attemptCount?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  databaseId?: InputMaybe<SortEnumType>;
  enqueueTime?: InputMaybe<SortEnumType>;
  hostname?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  jobType?: InputMaybe<SortEnumType>;
  lastProcessTime?: InputMaybe<SortEnumType>;
  originationTime?: InputMaybe<SortEnumType>;
  partitionGroup?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  raveUrl?: InputMaybe<SortEnumType>;
  requestId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type LegionTask = {
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
};

export type LegionTaskData = {
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  jobId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

export type LegionTaskFilterInput = {
  and?: InputMaybe<Array<LegionTaskFilterInput>>;
  attemptCount?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  insertedOn?: InputMaybe<DateTimeOperationFilterInput>;
  lastProcessedOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LegionTaskFilterInput>>;
  partitionKey?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<TaskItemStatusOperationFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
};

export type ListFilterInputTypeOfLegionTaskFilterInput = {
  all?: InputMaybe<LegionTaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LegionTaskFilterInput>;
  some?: InputMaybe<LegionTaskFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocalizationMessageItem = {
  __typename?: 'LocalizationMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  culture?: Maybe<Scalars['String']>;
  dateFormat?: Maybe<Scalars['String']>;
  dateTimeFormat?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionUuid: Scalars['UUID'];
  helpFolder?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  localizationUuid: Scalars['UUID'];
  nameFormat?: Maybe<Scalars['String']>;
  numberFormat?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  submitOnEnter: Scalars['Boolean'];
  updated: Scalars['DateTime'];
};

export type LocalizedDataStringMessage = EventMessage & IEventMessage & {
  __typename?: 'LocalizedDataStringMessage';
  body: LocalizedDataStringMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type LocalizedDataStringMessageBody = {
  __typename?: 'LocalizedDataStringMessageBody';
  avroSize: Scalars['Long'];
  locale: Scalars['String'];
  localizedDataStringId?: Maybe<Scalars['Long']>;
  localizedDataStringUuid?: Maybe<Scalars['UUID']>;
  metadata?: Maybe<Metadata>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  stringUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
  value: Scalars['String'];
};

export type LocalizedStringMessage = EventMessage & IEventMessage & {
  __typename?: 'LocalizedStringMessage';
  body: LocalizedStringMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type LocalizedStringMessageBody = {
  __typename?: 'LocalizedStringMessageBody';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  locale: Scalars['String'];
  localizedStringId?: Maybe<Scalars['Long']>;
  localizedStringUuid?: Maybe<Scalars['UUID']>;
  metadata?: Maybe<Metadata>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  stringUuid: Scalars['UUID'];
  translationStatus?: Maybe<Scalars['Long']>;
  updated: Scalars['DateTime'];
  value: Scalars['String'];
};

export type MarkingGroupCategoryMessageItem = {
  __typename?: 'MarkingGroupCategoryMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export type MarkingGroupMessageItem = {
  __typename?: 'MarkingGroupMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  markingGroupActive: Scalars['Boolean'];
  markingGroupCategoryId?: Maybe<Scalars['Int']>;
  markingGroupCategoryName?: Maybe<Scalars['String']>;
  markingGroupName?: Maybe<Scalars['String']>;
  markingGroupNameUuid: Scalars['UUID'];
  markingGroupUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  updated: Scalars['DateTime'];
};

export type MarkingMessageItem = {
  __typename?: 'MarkingMessageItem';
  acknowledgeUserUuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  answerData?: Maybe<Scalars['String']>;
  answerHash?: Maybe<Scalars['String']>;
  answerOnChange?: Maybe<Scalars['Boolean']>;
  answerText?: Maybe<Scalars['String']>;
  answerUserUuid?: Maybe<Scalars['UUID']>;
  answered?: Maybe<Scalars['DateTime']>;
  avroSize: Scalars['Long'];
  checkHash?: Maybe<Scalars['String']>;
  closeOnChange?: Maybe<Scalars['Boolean']>;
  created: Scalars['DateTime'];
  dataPointUuid: Scalars['UUID'];
  markingActive: Scalars['Boolean'];
  markingGroupUuid?: Maybe<Scalars['UUID']>;
  markingId?: Maybe<Scalars['Long']>;
  markingTypeId: Scalars['Int'];
  markingUuid: Scalars['UUID'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  queryData?: Maybe<Scalars['String']>;
  queryStatusId?: Maybe<Scalars['Int']>;
  requiresResponse?: Maybe<Scalars['Boolean']>;
  resolveUserUuid?: Maybe<Scalars['UUID']>;
  resolved?: Maybe<Scalars['DateTime']>;
  string?: Maybe<Scalars['String']>;
  stringUuid?: Maybe<Scalars['UUID']>;
  text: Scalars['String'];
  tokenData?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  userUuid?: Maybe<Scalars['UUID']>;
};

export type MatrixDefinitionMessageItem = {
  __typename?: 'MatrixDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  matrixDefinitionUuid: Scalars['UUID'];
  matrixOid: Scalars['String'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
};

export type MatrixVersionMessageItem = {
  __typename?: 'MatrixVersionMessageItem';
  addable: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  matrixDefinitionUuid: Scalars['UUID'];
  matrixName?: Maybe<Scalars['String']>;
  matrixNameUuid: Scalars['UUID'];
  matrixVersionUuid: Scalars['UUID'];
  maximum?: Maybe<Scalars['Int']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  _mdsol_lineage?: Maybe<Array<Array<KeyValuePairOfStringAndString>>>;
  _mdsol_timeliness?: Maybe<Array<KeyValuePairOfStringAndString>>;
  _mdsol_updated_at?: Maybe<Scalars['DateTime']>;
  defaultLocale?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  jobRequestId?: Maybe<Scalars['UUID']>;
  messageContentType?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['UUID']>;
  messageTime?: Maybe<Scalars['DateTime']>;
  multiMessageCount?: Maybe<Scalars['Int']>;
  multiMessageIndex?: Maybe<Scalars['Int']>;
  multiMessageUuid?: Maybe<Scalars['UUID']>;
  raveDatabaseVersion?: Maybe<Scalars['String']>;
  raveUrl?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  roleUuid?: Maybe<Scalars['UUID']>;
  studyGroupUuid?: Maybe<Scalars['UUID']>;
  targetObjectType?: Maybe<Scalars['String']>;
  targetObjectUuid?: Maybe<Scalars['UUID']>;
  traceparent?: Maybe<Scalars['String']>;
  transactionEndTime?: Maybe<Scalars['DateTime']>;
  transactionId?: Maybe<Scalars['String']>;
  userLogin?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['UUID']>;
};

export type ModuleMessageItem = {
  __typename?: 'ModuleMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export type Mutation = {
  __typename?: 'Mutation';
  bulkEditConfiguration: BulkEditConfigurationPayload;
  databaseEnableUpdate: DatabaseEnableUpdatePayload;
  deleteCustomConfigOverrideTag?: Maybe<DeleteCustomConfigOverrideTagPayload>;
  featureFlagUpdate: FeatureFlagUpdatePayload;
  jobRequest: JobRequestPayload;
  jobReschedule: JobReschedulePayload;
};


export type MutationBulkEditConfigurationArgs = {
  input: BulkEditConfigurationInput;
};


export type MutationDatabaseEnableUpdateArgs = {
  input: DatabaseEnableUpdateInput;
};


export type MutationDeleteCustomConfigOverrideTagArgs = {
  input: DeleteCustomConfigOverrideTagInput;
};


export type MutationFeatureFlagUpdateArgs = {
  input: FeatureFlagUpdateInput;
};


export type MutationJobRequestArgs = {
  input: JobRequestInput;
};


export type MutationJobRescheduleArgs = {
  input: JobRescheduleInput;
};

export type NotificationCenterDeferredTask = {
  __typename?: 'NotificationCenterDeferredTask';
  notificationQueueId: Scalars['Long'];
};

export type NotificationCenterJob = LegionJob & {
  __typename?: 'NotificationCenterJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type NotificationCenterTask = LegionTask & {
  __typename?: 'NotificationCenterTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  notificationQueueId: Scalars['Long'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
};

export type ObjectTagMessage = EventMessage & IEventMessage & {
  __typename?: 'ObjectTagMessage';
  body: ObjectTagMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type ObjectTagMessageBody = {
  __typename?: 'ObjectTagMessageBody';
  active?: Maybe<Scalars['Boolean']>;
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  fieldOid?: Maybe<Scalars['String']>;
  folderOid?: Maybe<Scalars['String']>;
  formOid?: Maybe<Scalars['String']>;
  metadata?: Maybe<ObjectTagMetadata>;
  objectKey: Scalars['String'];
  objectTagUuid: Scalars['UUID'];
  objectTypeId: Scalars['Int'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
  tag: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type ObjectTagMetadata = {
  __typename?: 'ObjectTagMetadata';
  _mdsol_lineage?: Maybe<Array<Array<KeyValuePairOfStringAndString>>>;
  _mdsol_timeliness?: Maybe<Array<KeyValuePairOfStringAndString>>;
  _mdsol_updated_at?: Maybe<Scalars['DateTime']>;
  defaultLocale?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  jobRequestId?: Maybe<Scalars['UUID']>;
  messageContentType?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['UUID']>;
  messageTime?: Maybe<Scalars['DateTime']>;
  multiMessageCount?: Maybe<Scalars['Int']>;
  multiMessageIndex?: Maybe<Scalars['Int']>;
  multiMessageUuid?: Maybe<Scalars['UUID']>;
  raveDatabaseVersion?: Maybe<Scalars['String']>;
  raveUrl?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  roleUuid?: Maybe<Scalars['UUID']>;
  studyGroupUuid?: Maybe<Scalars['UUID']>;
  studyUuid?: Maybe<Scalars['UUID']>;
  targetObjectType?: Maybe<Scalars['String']>;
  targetObjectUuid?: Maybe<Scalars['UUID']>;
  traceparent?: Maybe<Scalars['String']>;
  transactionEndTime?: Maybe<Scalars['DateTime']>;
  transactionId?: Maybe<Scalars['String']>;
  userLogin?: Maybe<Scalars['String']>;
  userUuid?: Maybe<Scalars['UUID']>;
};

export enum ObjectType {
  Activation = 'ACTIVATION',
  Analyte = 'ANALYTE',
  AnalyteRange = 'ANALYTE_RANGE',
  Batch = 'BATCH',
  BatchPage = 'BATCH_PAGE',
  Block = 'BLOCK',
  BlockPlan = 'BLOCK_PLAN',
  BlockPlanEnvironment = 'BLOCK_PLAN_ENVIRONMENT',
  BlockPlanRule = 'BLOCK_PLAN_RULE',
  BlockPlanRulesAudited = 'BLOCK_PLAN_RULES_AUDITED',
  BlockPlanRuleAction = 'BLOCK_PLAN_RULE_ACTION',
  BlockPlanRuleActionAudited = 'BLOCK_PLAN_RULE_ACTION_AUDITED',
  BlockPlanRuleAudited = 'BLOCK_PLAN_RULE_AUDITED',
  BlockPlanRuleStepAudited = 'BLOCK_PLAN_RULE_STEP_AUDITED',
  BlockTier = 'BLOCK_TIER',
  ChangeCode = 'CHANGE_CODE',
  Check = 'CHECK',
  CheckAction = 'CHECK_ACTION',
  CheckStep = 'CHECK_STEP',
  ClinicalSignificanceCode = 'CLINICAL_SIGNIFICANCE_CODE',
  CoderConfiguration = 'CODER_CONFIGURATION',
  CoderDecision = 'CODER_DECISION',
  CoderFieldConfigurationWorkFlowData = 'CODER_FIELD_CONFIGURATION_WORK_FLOW_DATA',
  CoderLinkedFieldConfiguration = 'CODER_LINKED_FIELD_CONFIGURATION',
  CoderValue = 'CODER_VALUE',
  CodingValue = 'CODING_VALUE',
  Column = 'COLUMN',
  Comment = 'COMMENT',
  Configuration = 'CONFIGURATION',
  Course = 'COURSE',
  CourseLocaleFile = 'COURSE_LOCALE_FILE',
  CourseStudyRole = 'COURSE_STUDY_ROLE',
  CrfDraft = 'CRF_DRAFT',
  CrfVersion = 'CRF_VERSION',
  CustomFunction = 'CUSTOM_FUNCTION',
  CustomObject = 'CUSTOM_OBJECT',
  CustomTier = 'CUSTOM_TIER',
  DataDictionary = 'DATA_DICTIONARY',
  DataDictionaryEntry = 'DATA_DICTIONARY_ENTRY',
  DataPage = 'DATA_PAGE',
  DataPoint = 'DATA_POINT',
  Dcf = 'DCF',
  DcfQuery = 'DCF_QUERY',
  DcfStatus = 'DCF_STATUS',
  DcfTransmission = 'DCF_TRANSMISSION',
  DcfTransmissionContent = 'DCF_TRANSMISSION_CONTENT',
  DcfTransmissionType = 'DCF_TRANSMISSION_TYPE',
  Derivation = 'DERIVATION',
  DerivationStep = 'DERIVATION_STEP',
  DraftCustomTier = 'DRAFT_CUSTOM_TIER',
  DraftRangeType = 'DRAFT_RANGE_TYPE',
  DraftVariableMapping = 'DRAFT_VARIABLE_MAPPING',
  EmailEventDetail = 'EMAIL_EVENT_DETAIL',
  ExcludedSubjectStatuses = 'EXCLUDED_SUBJECT_STATUSES',
  ExternalSystem = 'EXTERNAL_SYSTEM',
  ExternalUser = 'EXTERNAL_USER',
  Field = 'FIELD',
  Folder = 'FOLDER',
  FolderForm = 'FOLDER_FORM',
  Form = 'FORM',
  FormField = 'FORM_FIELD',
  FormFolder = 'FORM_FOLDER',
  GlobalDataDictionary = 'GLOBAL_DATA_DICTIONARY',
  GlobalDataDictionaryEntry = 'GLOBAL_DATA_DICTIONARY_ENTRY',
  GlobalLibraryProposal = 'GLOBAL_LIBRARY_PROPOSAL',
  GlobalLibraryVolume = 'GLOBAL_LIBRARY_VOLUME',
  GlobalUnitDictionary = 'GLOBAL_UNIT_DICTIONARY',
  GlobalUnitDictionaryEntry = 'GLOBAL_UNIT_DICTIONARY_ENTRY',
  GlobalVariable = 'GLOBAL_VARIABLE',
  Instance = 'INSTANCE',
  InPlaceEntry = 'IN_PLACE_ENTRY',
  Lab = 'LAB',
  LabAssignment = 'LAB_ASSIGNMENT',
  LabStandardGroup = 'LAB_STANDARD_GROUP',
  LabStandardGroupEntry = 'LAB_STANDARD_GROUP_ENTRY',
  LabUnit = 'LAB_UNIT',
  LabUnitConversion = 'LAB_UNIT_CONVERSION',
  LabUnitDictionary = 'LAB_UNIT_DICTIONARY',
  LabUnitDictionaryEntry = 'LAB_UNIT_DICTIONARY_ENTRY',
  LibraryIcon = 'LIBRARY_ICON',
  Locale = 'LOCALE',
  LocalizedString = 'LOCALIZED_STRING',
  LocalLab = 'LOCAL_LAB',
  Log = 'LOG',
  MarkingGroup = 'MARKING_GROUP',
  Matrix = 'MATRIX',
  MigrationConfiguration = 'MIGRATION_CONFIGURATION',
  MissingCode = 'MISSING_CODE',
  OidPath = 'OID_PATH',
  PdfConfiguration = 'PDF_CONFIGURATION',
  PlannedEnrollment = 'PLANNED_ENROLLMENT',
  ProfileDescription = 'PROFILE_DESCRIPTION',
  Project = 'PROJECT',
  ProtocolDeviation = 'PROTOCOL_DEVIATION',
  ProtocolDeviationClassR = 'PROTOCOL_DEVIATION_CLASS_R',
  ProtocolDeviationCodeR = 'PROTOCOL_DEVIATION_CODE_R',
  Query = 'QUERY',
  Question = 'QUESTION',
  Questionnaire = 'QUESTIONNAIRE',
  RangeType = 'RANGE_TYPE',
  RangeTypeVariable = 'RANGE_TYPE_VARIABLE',
  ReasonCode = 'REASON_CODE',
  Record = 'RECORD',
  Resource = 'RESOURCE',
  ReviewGroup = 'REVIEW_GROUP',
  ReviewStatus = 'REVIEW_STATUS',
  Role = 'ROLE',
  RoleAction = 'ROLE_ACTION',
  SdvBlockSubject = 'SDV_BLOCK_SUBJECT',
  SecurityGroup = 'SECURITY_GROUP',
  Signature = 'SIGNATURE',
  Site = 'SITE',
  SiteGroup = 'SITE_GROUP',
  Sticky = 'STICKY',
  Study = 'STUDY',
  StudySite = 'STUDY_SITE',
  Subject = 'SUBJECT',
  SubjectStatus = 'SUBJECT_STATUS',
  SystemUser = 'SYSTEM_USER',
  TierForm = 'TIER_FORM',
  UnitDictionary = 'UNIT_DICTIONARY',
  UnitDictionaryEntry = 'UNIT_DICTIONARY_ENTRY',
  Unknown = 'UNKNOWN',
  User = 'USER',
  UserGroup = 'USER_GROUP',
  Variable = 'VARIABLE',
  VersionRangeType = 'VERSION_RANGE_TYPE',
  VersionVariableMapping = 'VERSION_VARIABLE_MAPPING',
  ViewControl = 'VIEW_CONTROL',
  ViewProject = 'VIEW_PROJECT'
}

export type ObjectTypeMessageItem = {
  __typename?: 'ObjectTypeMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export enum OperationType {
  CurrentState = 'CURRENT_STATE',
  Deleted = 'DELETED',
  Derived = 'DERIVED',
  Modified = 'MODIFIED',
  Supplemental = 'SUPPLEMENTAL'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PlatformObjectMessage = EventMessage & IEventMessage & {
  __typename?: 'PlatformObjectMessage';
  body: PlatformObjectMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type PlatformObjectMessageBody = {
  __typename?: 'PlatformObjectMessageBody';
  avroSize: Scalars['Long'];
  clientDivisionOrganizations: Array<ClientDivisionOrganizationMessageItem>;
  metadata: Metadata;
  studies: Array<StudyMessageItem>;
  studyEnvironmentSites: Array<StudyEnvironmentSiteMessageItem>;
  studyEnvironments: Array<StudyEnvironmentMessageItem>;
};

export type ProtocolDeviationClassMessageItem = {
  __typename?: 'ProtocolDeviationClassMessageItem';
  active: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  classValue?: Maybe<Scalars['String']>;
  classValueUuid: Scalars['UUID'];
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  protocolDeviationClassUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type ProtocolDeviationCodeMessageItem = {
  __typename?: 'ProtocolDeviationCodeMessageItem';
  active: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  codeValue?: Maybe<Scalars['String']>;
  codeValueUuid: Scalars['UUID'];
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  protocolDeviationCodeUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type Query = {
  __typename?: 'Query';
  configurationOptions: Array<ConfigurationOption>;
  customConfigOverrides: Array<CustomConfigOverridesState>;
  dataVerificationHashObjectOptions: Array<DataVerificationHashObject>;
  databaseCountByAppVersion: Array<AppCountMetric>;
  databaseCountByDatabaseVersion: Array<AppCountMetric>;
  databases: Array<DatabaseMetadata>;
  diagnosticOptions: Array<DiagnosticOption>;
  diagnostics?: Maybe<DiagnosticsCollectionSegment>;
  downloadJobReport: ReportResult;
  featureFlags: Array<FeatureFlagStatus>;
  jobCountByType: Array<JobTypeMetric>;
  jobCountByUrl: Array<AppCountMetric>;
  jobRequest?: Maybe<JobRequest>;
  jobRequestOptions: Array<JobCreatorOptions>;
  jobRequests?: Maybe<JobRequestsConnection>;
  jobStatusCount: Array<JobStatusMetric>;
  jobTypeActionOptions: Array<JobTypeActionOptions>;
  jobTypeOptions: Array<JobTypeOption>;
  jobs?: Maybe<JobsConnection>;
  studies: Array<StudyMetadata>;
  studyEnvironments: Array<StudyEnvironmentMetadata>;
};


export type QueryCustomConfigOverridesArgs = {
  customConfigOverrides: Array<Scalars['String']>;
  databaseId: Scalars['UUID'];
};


export type QueryDatabasesArgs = {
  order?: InputMaybe<Array<DatabaseMetadataSortInput>>;
  where?: InputMaybe<DatabaseMetadataFilterInput>;
};


export type QueryDiagnosticsArgs = {
  databaseId: Scalars['UUID'];
  searchText?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<DiagnosticSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  type: DiagnosticType;
};


export type QueryDownloadJobReportArgs = {
  jobId: Scalars['UUID'];
};


export type QueryFeatureFlagsArgs = {
  databaseId: Scalars['UUID'];
};


export type QueryJobCountByTypeArgs = {
  databaseIds?: InputMaybe<Array<Scalars['UUID']>>;
  jobsStatuses?: InputMaybe<Array<JobStatus>>;
};


export type QueryJobCountByUrlArgs = {
  databaseIds?: InputMaybe<Array<Scalars['UUID']>>;
  jobsStatuses?: InputMaybe<Array<JobStatus>>;
};


export type QueryJobRequestArgs = {
  requestId: Scalars['UUID'];
};


export type QueryJobRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<JobRequestSortInput>>;
  where?: InputMaybe<JobRequestFilterInput>;
};


export type QueryJobStatusCountArgs = {
  databaseIds?: InputMaybe<Array<Scalars['UUID']>>;
  jobsStatuses?: InputMaybe<Array<JobStatus>>;
};


export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LegionJobSortInput>>;
  where?: InputMaybe<LegionJobFilterInput>;
};


export type QueryStudiesArgs = {
  databaseId: Scalars['UUID'];
};


export type QueryStudyEnvironmentsArgs = {
  databaseId: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
};

export type QueryStatusMessageItem = {
  __typename?: 'QueryStatusMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export type RaveUserMessage = EventMessage & IEventMessage & {
  __typename?: 'RaveUserMessage';
  body: RaveUserMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type RaveUserMessageBody = {
  __typename?: 'RaveUserMessageBody';
  avroSize: Scalars['Long'];
  externalUsers: Array<ExternalUserMessageItem>;
  internalUsers: Array<InternalUserMessageItem>;
  metadata: Metadata;
};

export type RecordMessageItem = {
  __typename?: 'RecordMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  dataPageUuid: Scalars['UUID'];
  deleted: Scalars['Boolean'];
  entryTime?: Maybe<Scalars['DateTime']>;
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  lockTime?: Maybe<Scalars['DateTime']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  primaryReviewTime?: Maybe<Scalars['DateTime']>;
  recordActive: Scalars['Boolean'];
  recordDate?: Maybe<Scalars['DateTime']>;
  recordId?: Maybe<Scalars['Long']>;
  recordPosition: Scalars['Int'];
  recordUuid: Scalars['UUID'];
  secondaryReviewTime?: Maybe<Scalars['DateTime']>;
  subjectMatrixUuid?: Maybe<Scalars['UUID']>;
  subjectUuid: Scalars['UUID'];
  tertiaryReviewTime?: Maybe<Scalars['DateTime']>;
  updated: Scalars['DateTime'];
  verifyTime?: Maybe<Scalars['DateTime']>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  content: Scalars['String'];
  type: ReportType;
};

export enum ReportType {
  Csv = 'CSV',
  Json = 'JSON'
}

export type ReviewGroupMessageItem = {
  __typename?: 'ReviewGroupMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  reviewGroupActive: Scalars['Boolean'];
  reviewGroupName?: Maybe<Scalars['String']>;
  reviewGroupNameUuid: Scalars['UUID'];
  reviewGroupUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type RoleActionMessageItem = {
  __typename?: 'RoleActionMessageItem';
  actionTypeId: Scalars['Int'];
  actionTypeName: Scalars['String'];
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  markingGroupUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  restrictionMask: Scalars['Long'];
  restrictionStatus: Scalars['Long'];
  reviewGroupUuid?: Maybe<Scalars['UUID']>;
  roleActionUuid: Scalars['UUID'];
  roleUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type RoleMessageItem = {
  __typename?: 'RoleMessageItem';
  active: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  canBatchSign: Scalars['Boolean'];
  canInactivateForm: Scalars['Boolean'];
  canModifyTemplates: Scalars['Boolean'];
  canReactivateForm: Scalars['Boolean'];
  canUseAdvancedDCFs: Scalars['Boolean'];
  canUseDCFs: Scalars['Boolean'];
  canUseTemplates: Scalars['Boolean'];
  canViewStudyGrid: Scalars['Boolean'];
  changeInvestigator: Scalars['Boolean'];
  createSubjects: Scalars['Boolean'];
  created: Scalars['DateTime'];
  isInvestigator: Scalars['Boolean'];
  modifyPrimaryRecord: Scalars['Boolean'];
  moduleId?: Maybe<Scalars['Int']>;
  moduleName?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  pass1DataEntry: Scalars['Boolean'];
  pass2DataEntry: Scalars['Boolean'];
  reconcile: Scalars['Boolean'];
  roleName?: Maybe<Scalars['String']>;
  roleNameUuid: Scalars['UUID'];
  rolePermissions: Scalars['Int'];
  roleUuid: Scalars['UUID'];
  seeAudits: Scalars['Boolean'];
  setClinicalSignificance: Scalars['Boolean'];
  shareSubject: Scalars['Boolean'];
  subjectAdmin: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  useLabMaintenance: Scalars['Boolean'];
  usePrimarySubjectName: Scalars['Boolean'];
  viewAllSites: Scalars['Boolean'];
  viewAllSubjects: Scalars['Boolean'];
};

export type RoleSubjectStatusAccessMessageItem = {
  __typename?: 'RoleSubjectStatusAccessMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  roleSubjectStatusAccessUuid: Scalars['UUID'];
  roleUuid: Scalars['UUID'];
  subjectStatusUuid: Scalars['UUID'];
};

export type ScriptUtilityJob = LegionJob & {
  __typename?: 'ScriptUtilityJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type ScriptUtilityLegionTask = LegionTask & {
  __typename?: 'ScriptUtilityLegionTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  latestRunOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  previousRunOn: Scalars['DateTime'];
  projectId: Scalars['Int'];
  queueTaskStatus: Scalars['Int'];
  scriptName: Scalars['String'];
  scriptUtilityRunId: Scalars['Int'];
  scriptUtilityTypeId: Scalars['Int'];
  status: TaskItemStatus;
  userId: Scalars['Int'];
};

export type ScriptUtilityRunParameterDto = {
  __typename?: 'ScriptUtilityRunParameterDto';
  completed: Scalars['Boolean'];
  parameterName?: Maybe<Scalars['String']>;
  scriptUtilityRunId?: Maybe<Scalars['Int']>;
  scriptUtilityRunParameterId: Scalars['Int'];
  scriptUtilityTypeParamID: Scalars['Int'];
  userString: Scalars['String'];
  value: Scalars['String'];
};

export type ScriptUtilityTask = {
  __typename?: 'ScriptUtilityTask';
  latestRunOn: Scalars['DateTime'];
  previousRunOn: Scalars['DateTime'];
  projectId: Scalars['Int'];
  queueTaskStatus: Scalars['Int'];
  scriptName: Scalars['String'];
  scriptUtilityRunId: Scalars['Int'];
  scriptUtilityTypeId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type SharedSubjectMessageItem = {
  __typename?: 'SharedSubjectMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  sharedSubjectUuid: Scalars['UUID'];
  studySiteUuid: Scalars['UUID'];
  subjectId?: Maybe<Scalars['Long']>;
  subjectUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type SignatureMessageItem = {
  __typename?: 'SignatureMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  fullName: Scalars['String'];
  isActive: Scalars['Boolean'];
  objectTypeId: Scalars['Byte'];
  objectUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  roleUuid: Scalars['UUID'];
  signatureHash: Scalars['String'];
  signatureId?: Maybe<Scalars['Long']>;
  signaturePrompt: Scalars['String'];
  signatureUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
  userUuid?: Maybe<Scalars['UUID']>;
};

export enum SimulantMode {
  Random = 'RANDOM',
  Simulated = 'SIMULATED'
}

export enum SimulantType {
  Patient = 'PATIENT',
  TestScenario = 'TEST_SCENARIO'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatusRollupDiagnostic = LegionDiagnostic & {
  __typename?: 'StatusRollupDiagnostic';
  completedOn?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Any']>;
  environmentName: Scalars['String'];
  hostname?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insertedOn?: Maybe<Scalars['DateTime']>;
  lastProcessedOn?: Maybe<Scalars['DateTime']>;
  objectId: Scalars['Int'];
  objectType: ObjectType;
  operation: DeferredRollupOperation;
  parentTaskId?: Maybe<Scalars['Int']>;
  refreshClinicalView: Scalars['Boolean'];
  requestId: Scalars['UUID'];
  retries: Scalars['Int'];
  roleId: Scalars['Int'];
  roleName: Scalars['String'];
  siteName: Scalars['String'];
  startedOn?: Maybe<Scalars['DateTime']>;
  status: TaskItemStatus;
  studyId: Scalars['Int'];
  studyName: Scalars['String'];
  subjectName: Scalars['String'];
  subjectUuid: Scalars['UUID'];
  taskId: Scalars['Int'];
  taskSource: Scalars['String'];
};

export type StatusRollupJob = LegionJob & {
  __typename?: 'StatusRollupJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  /** This is Rave Study equivalent to Platform StudyEnvironment. */
  studyId: Scalars['Int'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type StatusRollupProgress = LegionDiagnostic & {
  __typename?: 'StatusRollupProgress';
  completed: Scalars['Int'];
  completedPercent: Scalars['Float'];
  data?: Maybe<Scalars['Any']>;
  elapsedSeconds: Scalars['Long'];
  failed: Scalars['Int'];
  failedPercent: Scalars['Float'];
  finalError: Scalars['Int'];
  id: Scalars['String'];
  initiationDate?: Maybe<Scalars['DateTime']>;
  notStarted: Scalars['Int'];
  progress: Scalars['Float'];
  requestId: Scalars['UUID'];
  running: Scalars['Int'];
  taskCount: Scalars['Int'];
  taskSource: Scalars['String'];
};

export type StatusRollupTask = LegionTask & {
  __typename?: 'StatusRollupTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  objectId: Scalars['Int'];
  objectType: ObjectType;
  operationType: DeferredRollupOperation;
  parentTaskId?: Maybe<Scalars['Int']>;
  partitionKey: Scalars['String'];
  refreshClinicalView: Scalars['Boolean'];
  roleId: Scalars['Int'];
  status: TaskItemStatus;
  studyId: Scalars['Int'];
  taskId: Scalars['Int'];
};

/** Status as a 32-bit flagged enumeration. */
export type StatusesFlags = {
  __typename?: 'StatusesFlags';
  /**
   * "ActiveEntity" is false if:
   * A dataPoint or its parents are soft deleted.
   * In all other cases "ActiveEntity" is true.
   * In the database it is represented as the column "Capacity".
   */
  isActiveEntity: Scalars['Boolean'];
  /** The Status is deferred. */
  isDeferred: Scalars['Boolean'];
  /** Is Incomplete. */
  isIsIncomplete: Scalars['Boolean'];
  /** Is Non Conformant. */
  isIsNonConformant: Scalars['Boolean'];
  /** Is Not Empty. */
  isIsNotEmpty: Scalars['Boolean'];
  /** Is Not Frozen. */
  isIsNotFrozen: Scalars['Boolean'];
  /** Is Not Locked. */
  isIsNotLocked: Scalars['Boolean'];
  /** Is Overdue for entry. */
  isIsOverdue: Scalars['Boolean'];
  /** Is Pending a Review that your Role can not perform, but can see that it is Pending. */
  isIsPendingReview: Scalars['Boolean'];
  /**
   * "IsReadyForSignature" is true if:
   * A datapoint is submitted / touched and Requires signature.
   * This is different from the RequiresSignature bit because the object must be touched for it to be true.
   * The RequiresSignature status bit does not take into account IsTouched.
   */
  isIsReadyForSignature: Scalars['Boolean'];
  /** Is Reviewed. */
  isIsReviewed: Scalars['Boolean'];
  /** Is the Signature not current. */
  isIsSignatureNotCurrent: Scalars['Boolean'];
  /** Is A Sticky Placed. */
  isIsStickyPlaced: Scalars['Boolean'];
  /** Has ever been touched. */
  isIsTouched: Scalars['Boolean'];
  /** Is this object Source Document Verified. */
  isIsVerified: Scalars['Boolean'];
  /** No Status. */
  isNone: Scalars['Boolean'];
  /**
   * Indicates if the DataPage can be EntryLocked (or frozen).
   *
   * This Bit is NOT set for any StatusObject below the DataPage and should not be preconditioned on.
   */
  isPageReadyForFreeze: Scalars['Boolean'];
  /**
   * Indicates if the DataPage can be HardLocked.
   *
   * This Bit is NOT set for any StatusObject below the DataPage and should not be preconditioned on.
   */
  isPageReadyForLock: Scalars['Boolean'];
  /** Requires Answer Query. */
  isRequiresAnswerQuery: Scalars['Boolean'];
  /** Require Cancel Query and it will also be calculated in rollup. */
  isRequiresCancelQuery: Scalars['Boolean'];
  /** Requires Close Query. */
  isRequiresCloseQuery: Scalars['Boolean'];
  isRequiresCoderCoding: Scalars['Boolean'];
  /** Requires Coding. */
  isRequiresCoding: Scalars['Boolean'];
  /** Is Pending an Answer Query that your Role can not perform, but can see that it is Pending. */
  isRequiresPendingAnswerQuery: Scalars['Boolean'];
  /** Is Pending a Close Query that your Role can not perform, but can see that it is Pending. */
  isRequiresPendingCloseQuery: Scalars['Boolean'];
  /** Requires Reconciliation (for DDE). */
  isRequiresReconciliation: Scalars['Boolean'];
  /** Requires Review. */
  isRequiresReview: Scalars['Boolean'];
  /** Requires Second Pass Entry (for DDE). */
  isRequiresSecondPass: Scalars['Boolean'];
  /** Does the StatusObject actually require Signature. */
  isRequiresSignature: Scalars['Boolean'];
  /** Requires Translation. */
  isRequiresTranslation: Scalars['Boolean'];
  /** Requires Source Document Verification. */
  isRequiresVerification: Scalars['Boolean'];
  /** Was this object ever Signed. */
  isWasSigned: Scalars['Boolean'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StudyEnvironmentMessageItem = {
  __typename?: 'StudyEnvironmentMessageItem';
  allowLockedDataPointChange: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  defaultCrfVersionUuid?: Maybe<Scalars['UUID']>;
  deleted: Scalars['Boolean'];
  enrollmentTarget?: Maybe<Scalars['Int']>;
  environment: Scalars['String'];
  environmentStringUuid?: Maybe<Scalars['UUID']>;
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  lastExternalUpdateDate?: Maybe<Scalars['DateTime']>;
  oid?: Maybe<Scalars['String']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  preventExecuteChecksOnCoderDictionaryVersionUpdate: Scalars['Boolean'];
  startDate?: Maybe<Scalars['DateTime']>;
  studyEnvironmentActive: Scalars['Boolean'];
  studyEnvironmentId?: Maybe<Scalars['Long']>;
  studyEnvironmentSubjectCount: Scalars['Int'];
  studyEnvironmentUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
  testStudyEnvironment: Scalars['Boolean'];
  updated: Scalars['DateTime'];
};

export type StudyEnvironmentMetadata = {
  __typename?: 'StudyEnvironmentMetadata';
  studyEnvironmentName: Scalars['String'];
  studyEnvironmentUuid: Scalars['String'];
  /** This is Rave Study equivalent to Platform StudyEnvironment. */
  studyId: Scalars['Int'];
};

export type StudyEnvironmentSiteMessageItem = {
  __typename?: 'StudyEnvironmentSiteMessageItem';
  allowUnitsOnly: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  clientDivisionOrganizationUuid: Scalars['UUID'];
  created: Scalars['DateTime'];
  crfVersionUuid?: Maybe<Scalars['UUID']>;
  defaultLabType: Scalars['Int'];
  deleted: Scalars['Boolean'];
  enrollmentCap?: Maybe<Scalars['Int']>;
  enrollmentTarget?: Maybe<Scalars['Int']>;
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  lastExternalUpdateDate?: Maybe<Scalars['DateTime']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyEnvironmentSiteId?: Maybe<Scalars['Long']>;
  studyEnvironmentSiteUuid: Scalars['UUID'];
  studyEnvironmentUuid: Scalars['UUID'];
  studySiteActive: Scalars['Boolean'];
  studySiteNumber?: Maybe<Scalars['String']>;
  studySiteSubjectCount: Scalars['Int'];
  updated: Scalars['DateTime'];
};

export type StudyEnvironmentSiteSupplementalItem = {
  __typename?: 'StudyEnvironmentSiteSupplementalItem';
  avroSize: Scalars['Long'];
  siteUuid: Scalars['UUID'];
  studyEnvironmentSiteId?: Maybe<Scalars['Long']>;
  studyEnvironmentSiteNumber?: Maybe<Scalars['String']>;
  studyEnvironmentSiteUuid: Scalars['UUID'];
  studyEnvironmentUuid: Scalars['UUID'];
};

export type StudyEnvironmentSupplementalItem = {
  __typename?: 'StudyEnvironmentSupplementalItem';
  avroSize: Scalars['Long'];
  environment: Scalars['String'];
  environmentUuid?: Maybe<Scalars['UUID']>;
  studyEnvironmentId?: Maybe<Scalars['Long']>;
  studyEnvironmentUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
};

export type StudyMessageItem = {
  __typename?: 'StudyMessageItem';
  abbreviation?: Maybe<Scalars['String']>;
  abbreviationStringUuid?: Maybe<Scalars['UUID']>;
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  createdByUserUuid?: Maybe<Scalars['UUID']>;
  customerApiCompatibilityVersion: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  descriptionStringUuid?: Maybe<Scalars['UUID']>;
  enableVerifyReviewOnInactive?: Maybe<Scalars['Boolean']>;
  isAllCopySources: Scalars['Boolean'];
  isClassic: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  isRcmEnabled: Scalars['Boolean'];
  legacyCustomerApiCompatibilityVersion: Scalars['Int'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  pageRedirection: Scalars['Int'];
  studyActive: Scalars['Boolean'];
  studyId?: Maybe<Scalars['Long']>;
  studyName: Scalars['String'];
  studyNameUuid?: Maybe<Scalars['UUID']>;
  studyTypeId: Scalars['Int'];
  studyUuid: Scalars['UUID'];
  updated?: Maybe<Scalars['DateTime']>;
};

export type StudyMetadata = {
  __typename?: 'StudyMetadata';
  studyName: Scalars['String'];
  studyUuid: Scalars['String'];
};

export type StudySupplementalItem = {
  __typename?: 'StudySupplementalItem';
  avroSize: Scalars['Long'];
  sourceSystemId: Scalars['Int'];
  studyId?: Maybe<Scalars['Long']>;
  studyName: Scalars['String'];
  studyNameUuid?: Maybe<Scalars['UUID']>;
  studyUuid: Scalars['UUID'];
};

export type SubjectMatrixMessageItem = {
  __typename?: 'SubjectMatrixMessageItem';
  active: Scalars['Boolean'];
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  matrixAction?: Maybe<Scalars['Byte']>;
  matrixExternalUuid?: Maybe<Scalars['UUID']>;
  matrixVersionUuid: Scalars['UUID'];
  objectTypeId: Scalars['Byte'];
  objectUuid?: Maybe<Scalars['UUID']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  subjectMatrixId?: Maybe<Scalars['Long']>;
  subjectMatrixUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type SubjectMessageItem = {
  __typename?: 'SubjectMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  createdByUserUuid?: Maybe<Scalars['UUID']>;
  crfVersionExternalUuid?: Maybe<Scalars['UUID']>;
  crfVersionId?: Maybe<Scalars['Long']>;
  crfVersionUuid: Scalars['UUID'];
  currentInvestigatorUuid?: Maybe<Scalars['UUID']>;
  deleted: Scalars['Boolean'];
  initialInvestigatorUuid?: Maybe<Scalars['UUID']>;
  isAddEventLocked: Scalars['Boolean'];
  isCurrentInvestigatorExternal: Scalars['Boolean'];
  isInitialInvestigatorExternal: Scalars['Boolean'];
  isSentToBalanceUsingGuid?: Maybe<Scalars['Boolean']>;
  isUnavailable: Scalars['Boolean'];
  isUserDeactivated?: Maybe<Scalars['Boolean']>;
  isVersionChanged: Scalars['Boolean'];
  maxDate: Scalars['DateTime'];
  numberInStudyEnvironment: Scalars['Int'];
  numberInStudyEnvironmentSite: Scalars['Int'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  reasonDescription?: Maybe<Scalars['String']>;
  reasonDescriptionUuid?: Maybe<Scalars['UUID']>;
  requiresSignature?: Maybe<Scalars['Boolean']>;
  secondaryName?: Maybe<Scalars['String']>;
  studyEnvironmentSiteUuid: Scalars['UUID'];
  studyEnvironmentUuid: Scalars['UUID'];
  subjectActive: Scalars['Boolean'];
  subjectDate?: Maybe<Scalars['DateTime']>;
  subjectId?: Maybe<Scalars['Long']>;
  subjectName: Scalars['String'];
  subjectStatusUuid: Scalars['UUID'];
  subjectUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type SubjectStatusCategoryMessageItem = {
  __typename?: 'SubjectStatusCategoryMessageItem';
  avroSize: Scalars['Long'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  value: Scalars['Long'];
};

export type SubjectStatusHistoryMessageItem = {
  __typename?: 'SubjectStatusHistoryMessageItem';
  avroSize: Scalars['Long'];
  dateChanged: Scalars['DateTime'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['Long']>;
  subjectStatusHistoryUuid: Scalars['UUID'];
  subjectStatusUuid: Scalars['UUID'];
  subjectUuid: Scalars['UUID'];
};

export type SubjectStatusMessageItem = {
  __typename?: 'SubjectStatusMessageItem';
  avroSize: Scalars['Long'];
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  stringName?: Maybe<Scalars['String']>;
  stringNameUuid: Scalars['UUID'];
  subjectStatusCategoryId?: Maybe<Scalars['Int']>;
  subjectStatusCategoryName?: Maybe<Scalars['String']>;
  subjectStatusUuid: Scalars['UUID'];
  updated: Scalars['DateTime'];
};

export type SyntheticAnalyteRange = {
  __typename?: 'SyntheticAnalyteRange';
  clinicalSignificanceCodeUuid?: Maybe<Scalars['UUID']>;
  clinicalSignificanceComment?: Maybe<Scalars['String']>;
  labUnitUuid?: Maybe<Scalars['UUID']>;
};

export type SyntheticDataJob = LegionJob & {
  __typename?: 'SyntheticDataJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  crfVersionUuid: Scalars['UUID'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  environmentUuid: Scalars['UUID'];
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  mode: SimulantMode;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  patientCount: Scalars['Int'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  siteUuid: Scalars['UUID'];
  status: JobStatus;
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
  type: SimulantType;
};

export type SyntheticDataMessage = EventMessage & IEventMessage & {
  __typename?: 'SyntheticDataMessage';
  body: SyntheticDataMessageBody;
  eventMessageType: EventMessageTypeFlags;
  headers: Array<KeyValuePairOfStringAndListOfString>;
  id: Scalars['UUID'];
  partitionKey?: Maybe<Scalars['UUID']>;
};

export type SyntheticDataMessageBody = {
  __typename?: 'SyntheticDataMessageBody';
  logUuid: Scalars['UUID'];
  patientUuid?: Maybe<Scalars['UUID']>;
  scenarioUuid?: Maybe<Scalars['UUID']>;
  studyEnvironmentSiteUuid: Scalars['UUID'];
  studyEnvironmentUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
};

export type SyntheticDataPage = {
  __typename?: 'SyntheticDataPage';
  folderPath?: Maybe<Array<SyntheticObjectId>>;
  form: SyntheticObjectId;
  labUuid?: Maybe<Scalars['UUID']>;
  records: Array<SyntheticRecord>;
};

export type SyntheticDataPageState = {
  __typename?: 'SyntheticDataPageState';
  cleaningExecution?: Maybe<CleaningExecutionContext>;
  dataPageId?: Maybe<Scalars['Int']>;
  dataPageUuid?: Maybe<Scalars['UUID']>;
  input: SyntheticDataPage;
  status: SyntheticDataPageStatus;
};

export enum SyntheticDataPageStatus {
  Error = 'ERROR',
  None = 'NONE',
  NonConformant = 'NON_CONFORMANT',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type SyntheticDataPoint = {
  __typename?: 'SyntheticDataPoint';
  altCodedData?: Maybe<Scalars['String']>;
  analyteRange?: Maybe<SyntheticAnalyteRange>;
  changeCodeUuid?: Maybe<Scalars['UUID']>;
  data?: Maybe<Scalars['String']>;
  dataDictionaryEntryUuid?: Maybe<Scalars['UUID']>;
  fieldUuid: Scalars['UUID'];
  unitDictionaryEntryUuid?: Maybe<Scalars['UUID']>;
  version?: Maybe<Scalars['String']>;
};

export type SyntheticDataTask = LegionTask & {
  __typename?: 'SyntheticDataTask';
  attemptCount: Scalars['Int'];
  data?: Maybe<SyntheticDataTaskData>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  scenario?: Maybe<SyntheticDataTestScenario>;
  status: TaskItemStatus;
};

export type SyntheticDataTaskData = LegionTaskData & {
  __typename?: 'SyntheticDataTaskData';
  completedTime?: Maybe<Scalars['DateTime']>;
  createdTime: Scalars['DateTime'];
  forms: Array<SyntheticDataPageState>;
  jobId: Scalars['UUID'];
  patientName?: Maybe<Scalars['String']>;
  primaryForm: SyntheticPrimaryDataPageState;
  taskId: Scalars['UUID'];
};

export type SyntheticDataTestScenario = {
  __typename?: 'SyntheticDataTestScenario';
  dataPages: Array<SyntheticDataPage>;
  patientName?: Maybe<Scalars['String']>;
  primaryDataPage?: Maybe<SyntheticPrimaryDataPage>;
  testScenarioUuid: Scalars['UUID'];
};

export type SyntheticObjectId = {
  __typename?: 'SyntheticObjectId';
  repeatNumber?: Maybe<Scalars['Int']>;
  uuid: Scalars['UUID'];
};

export type SyntheticPrimaryDataPage = {
  __typename?: 'SyntheticPrimaryDataPage';
  dataPoints: Array<SyntheticDataPoint>;
  investigatorUuid?: Maybe<Scalars['UUID']>;
};

export type SyntheticPrimaryDataPageState = {
  __typename?: 'SyntheticPrimaryDataPageState';
  cleaningExecution?: Maybe<CleaningExecutionContext>;
  dataPageId?: Maybe<Scalars['Int']>;
  dataPageUuid?: Maybe<Scalars['UUID']>;
  input?: Maybe<SyntheticPrimaryDataPage>;
  patientId?: Maybe<Scalars['Int']>;
  patientUuid?: Maybe<Scalars['UUID']>;
  status: SyntheticDataPageStatus;
};

export type SyntheticRecord = {
  __typename?: 'SyntheticRecord';
  dataPoints: Array<SyntheticDataPoint>;
  position: Scalars['Int'];
};

export type TaskCount = {
  __typename?: 'TaskCount';
  /** Number of data pages with answered queries which the user can take action on. */
  answeredQuery: Scalars['Int'];
  /** Number of queries with answered status which the user can take action on. */
  answeredQueryCount: Scalars['Int'];
  /** Number of data pages with answered queries which the user can see but not take action on. */
  answeredQueryReadonly: Scalars['Int'];
  /** Number of queries with answered status which the user can see but not take action on. */
  answeredQueryReadonlyCount: Scalars['Int'];
  /** Number of data pages with cancel queries which the user can see but not take action on. */
  cancelQuery: Scalars['Int'];
  /** Number of queries which can be by the user can see but not take action on. */
  cancelQueryCount: Scalars['Int'];
  /** The number of data pages requiring coding. */
  coder: Scalars['Int'];
  /** The number of completed data pages. */
  complete: Scalars['Int'];
  /** The number of data pages which can be hard locked. */
  dataLock: Scalars['Int'];
  /** The number of data pages enqueued for hard locked. */
  dataLockEnqueued: Scalars['Int'];
  /** The number of data pages which can be frozen. */
  entryLock: Scalars['Int'];
  /** The number of data pages enqueued for entry locked. */
  entryLockEnqueued: Scalars['Int'];
  /** The number of frozen data pages. */
  frozen: Scalars['Int'];
  /** The number of inactive data pages. */
  inactive: Scalars['Int'];
  /** The number of incomplete data pages. */
  incomplete: Scalars['Int'];
  /** The number of locked data pages. */
  locked: Scalars['Int'];
  /** The number of data pages with non conformant data. */
  nonConformant: Scalars['Int'];
  /** The number of data pages which have data. */
  notEmpty: Scalars['Int'];
  /** The number of data pages which are not frozen. */
  notFrozen: Scalars['Int'];
  /** The number of data pages which are not locked. */
  notLocked: Scalars['Int'];
  /** The number of unsubmitted data pages. */
  notSubmitted: Scalars['Int'];
  /** Number of data pages with open queries which the user can take action on. */
  openQuery: Scalars['Int'];
  /** Number of queries with open status which the user can see but not take action on. */
  openQueryCount: Scalars['Int'];
  /** Number of data pages with open queries which the user can see but not take action on. */
  openQueryReadonly: Scalars['Int'];
  /** Number of queries with open status which the user can see but not take action on. */
  openQueryReadonlyCount: Scalars['Int'];
  /** The number of data pages which are overdue. */
  overdue: Scalars['Int'];
  /** The number of partially submitted data pages. */
  partiallySubmitted: Scalars['Int'];
  /** The number of data pages which requiring review and the user can take action on. */
  review: Scalars['Int'];
  /** The number of data pages enqueued for review. */
  reviewEnqueued: Scalars['Int'];
  /** The number of data pages which requiring review and the user can see but not take action on. */
  reviewReadonly: Scalars['Int'];
  /** The number distinct number of data pages which required review. Actionable or readonly reviews are count once per data page. */
  reviewRequired: Scalars['Int'];
  /** The number of data pages reviewed. */
  reviewed: Scalars['Int'];
  /** The number of data pages which requires signature. */
  signature: Scalars['Int'];
  /** The number of data pages enqueued for review. */
  signatureEnqueued: Scalars['Int'];
  /** The number of data pages with out of date signature. */
  signatureNotCurrent: Scalars['Int'];
  /** The number of data pages which require signature. */
  signatureRequired: Scalars['Int'];
  /** The number of signed data pages. */
  signed: Scalars['Int'];
  /** The number of data pages with sticky notes the user can take action on. */
  sticky: Scalars['Int'];
  /** The number of sticky notes the user can take action on. */
  stickyCount: Scalars['Int'];
  /** The number of data pages with sticky notes the user can see but not take action on. */
  stickyReadonly: Scalars['Int'];
  /** The number of sticky notes the user can see but not take action on. */
  stickyReadonlyCount: Scalars['Int'];
  /** The number of submitted data pages. */
  submitted: Scalars['Int'];
  /** The total number of active data pages. */
  total: Scalars['Int'];
  /** The number of data pages requiring translations. */
  translation: Scalars['Int'];
  /** The number of data pages requiring verified. */
  verified: Scalars['Int'];
  /** The number of data pages requiring verification. */
  verify: Scalars['Int'];
  /** The number of data pages enqueued for verify. */
  verifyEnqueued: Scalars['Int'];
};

export enum TaskItemStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Extracted = 'EXTRACTED',
  FinalError = 'FINAL_ERROR',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Skipped = 'SKIPPED'
}

export type TaskItemStatusOperationFilterInput = {
  eq?: InputMaybe<TaskItemStatus>;
  in?: InputMaybe<Array<TaskItemStatus>>;
  neq?: InputMaybe<TaskItemStatus>;
  nin?: InputMaybe<Array<TaskItemStatus>>;
};

export type TaskSummaryJob = LegionJob & {
  __typename?: 'TaskSummaryJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  studyId: Scalars['Int'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export enum TaskSummaryOperation {
  Delete = 'DELETE',
  PatientAdd = 'PATIENT_ADD',
  Refresh = 'REFRESH',
  Update = 'UPDATE'
}

export type TaskSummaryRecalculationJob = LegionJob & {
  __typename?: 'TaskSummaryRecalculationJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  performSiteLevelRecalculation: Scalars['Boolean'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  siteLevelRecalculationSuccessful?: Maybe<Scalars['Boolean']>;
  status: JobStatus;
  studyEnvironmentSiteUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type TaskSummaryRecalculationTask = LegionTask & {
  __typename?: 'TaskSummaryRecalculationTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  subjectUuid: Scalars['UUID'];
};

export type TaskSummaryTask = LegionTask & {
  __typename?: 'TaskSummaryTask';
  attemptCount: Scalars['Int'];
  dataPageIds: Array<Scalars['Int']>;
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  operation: TaskSummaryOperation;
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  subjectUuid: Scalars['UUID'];
};

export type TaskSummaryValidationJob = LegionJob & {
  __typename?: 'TaskSummaryValidationJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  performSiteLevelValidation: Scalars['Boolean'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  siteLevelValidationResult?: Maybe<Scalars['Boolean']>;
  siteValidationItems?: Maybe<Array<TaskValidationResult>>;
  status: JobStatus;
  studyEnvironmentSiteUuid: Scalars['UUID'];
  studyUuid: Scalars['UUID'];
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type TaskSummaryValidationTask = LegionTask & {
  __typename?: 'TaskSummaryValidationTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  subjectUuid: Scalars['UUID'];
  taskValidationItems?: Maybe<Array<TaskValidationResult>>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type TaskValidationResult = {
  __typename?: 'TaskValidationResult';
  childrenCount: TaskCount;
  parentCount: TaskCount;
  roleId: Scalars['String'];
};

export type TsdvComputeSubjectsReadyToAllocateDeferredTask = {
  __typename?: 'TsdvComputeSubjectsReadyToAllocateDeferredTask';
  statusId: Scalars['Int'];
  studyId: Scalars['Int'];
  subjectId: Scalars['Int'];
  taskId: Scalars['Int'];
};

export type TsdvComputeSubjectsReadyToAllocateJob = LegionJob & {
  __typename?: 'TsdvComputeSubjectsReadyToAllocateJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type TsdvComputeSubjectsReadyToAllocateLegionTask = LegionTask & {
  __typename?: 'TsdvComputeSubjectsReadyToAllocateLegionTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  status: TaskItemStatus;
  statusId: Scalars['Int'];
  studyId: Scalars['Int'];
  subjectId: Scalars['Int'];
  taskId: Scalars['Int'];
};

export type TsdvRetrospectiveDeferredTask = {
  __typename?: 'TsdvRetrospectiveDeferredTask';
  publishOrOverrideDate: Scalars['DateTime'];
  retries: Scalars['Int'];
  runReason: Scalars['String'];
  statusId: Scalars['Int'];
  studyId: Scalars['Int'];
  subjectId: Scalars['Int'];
  taskId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type TsdvRetrospectiveJob = LegionJob & {
  __typename?: 'TsdvRetrospectiveJob';
  attemptCount: Scalars['Int'];
  createdTime: Scalars['DateTime'];
  databaseId: Scalars['UUID'];
  enqueueTime?: Maybe<Scalars['DateTime']>;
  grafanaTraceLink: Scalars['String'];
  hostname: Scalars['String'];
  jobId: Scalars['UUID'];
  jobType: JobType;
  lastProcessTime?: Maybe<Scalars['DateTime']>;
  originationTime: Scalars['DateTime'];
  partitionGroup: Scalars['String'];
  priority: Scalars['Int'];
  raveUrl: Scalars['String'];
  requestId: Scalars['UUID'];
  status: JobStatus;
  sumoLogicTraceLink: Scalars['String'];
  tasks: Array<LegionTask>;
  traceHeaders?: Maybe<Array<KeyValuePairOfStringAndString>>;
};

export type TsdvRetrospectiveLegionTask = LegionTask & {
  __typename?: 'TsdvRetrospectiveLegionTask';
  attemptCount: Scalars['Int'];
  id: Scalars['UUID'];
  insertedOn: Scalars['DateTime'];
  lastProcessedOn: Scalars['DateTime'];
  partitionKey: Scalars['String'];
  publishOrOverrideDate: Scalars['DateTime'];
  retries: Scalars['Int'];
  runReason: Scalars['String'];
  status: TaskItemStatus;
  statusId: Scalars['Int'];
  studyId: Scalars['Int'];
  subjectId: Scalars['Int'];
  taskId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UnitDictionaryDefinitionMessageItem = {
  __typename?: 'UnitDictionaryDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
  unitDictionaryDefinitionUuid: Scalars['UUID'];
  unitDictionaryOid?: Maybe<Scalars['String']>;
};

export type UnitDictionaryEntryDefinitionMessageItem = {
  __typename?: 'UnitDictionaryEntryDefinitionMessageItem';
  avroSize: Scalars['Long'];
  codedUnit?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  unitDictionaryDefinitionUuid: Scalars['UUID'];
  unitDictionaryEntryDefinitionUuid: Scalars['UUID'];
};

export type UnitDictionaryEntryVersionMessageItem = {
  __typename?: 'UnitDictionaryEntryVersionMessageItem';
  avroSize: Scalars['Long'];
  codedUnit?: Maybe<Scalars['String']>;
  constantA?: Maybe<Scalars['Float']>;
  constantB?: Maybe<Scalars['Float']>;
  constantC?: Maybe<Scalars['Float']>;
  constantK?: Maybe<Scalars['Float']>;
  created?: Maybe<Scalars['DateTime']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  unitDictionaryDefinitionUuid: Scalars['UUID'];
  unitDictionaryEntryDefinitionUuid: Scalars['UUID'];
  unitDictionaryEntryName?: Maybe<Scalars['String']>;
  unitDictionaryEntryNameUuid: Scalars['UUID'];
  unitDictionaryEntryOid?: Maybe<Scalars['String']>;
  unitDictionaryEntryVersionUuid: Scalars['UUID'];
  userUnitString?: Maybe<Scalars['String']>;
  userUnitStringUuid?: Maybe<Scalars['UUID']>;
};

export type UnitDictionaryVersionMessageItem = {
  __typename?: 'UnitDictionaryVersionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  nameSpaceId: Scalars['Int'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  standardUnitDictionaryEntryDefinitionUuid?: Maybe<Scalars['UUID']>;
  unitDictionaryDefinitionUuid: Scalars['UUID'];
  unitDictionaryName?: Maybe<Scalars['String']>;
  unitDictionaryNameUuid: Scalars['UUID'];
  unitDictionaryOid?: Maybe<Scalars['String']>;
  unitDictionaryVersionUuid: Scalars['UUID'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type VariableDefinitionMessageItem = {
  __typename?: 'VariableDefinitionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  studyUuid: Scalars['UUID'];
  variableDefinitionUuid: Scalars['UUID'];
  variableOid?: Maybe<Scalars['String']>;
};

export type VariableVersionMessageItem = {
  __typename?: 'VariableVersionMessageItem';
  avroSize: Scalars['Long'];
  created?: Maybe<Scalars['DateTime']>;
  dataDictionaryDefinitionUuid?: Maybe<Scalars['UUID']>;
  dataFormat?: Maybe<Scalars['String']>;
  derivationDefinitionUuid?: Maybe<Scalars['UUID']>;
  nameSpaceID: Scalars['Int'];
  operationType: OperationType;
  operationTypeNumeric?: Maybe<Scalars['Int']>;
  unitDictionaryDefinitionUuid?: Maybe<Scalars['UUID']>;
  variableDefinitionUuid: Scalars['UUID'];
  variableName: Scalars['String'];
  variableVersionUuid: Scalars['UUID'];
};
